<template>
<div class="vx-row">
    <div class="vx-col w-full" fixed-height="true">
        <vx-card title="Prefacturas de clientes">
            <div class="flex mt-5">
                <div style="width: 40%;">
                    <p>
                        <ion-icon name="contract-outline"></ion-icon> Busqueda Institución/Punto de venta De Plataforma
                    </p>
                </div>
                <div style="width: 60%;">
                    <div class="flex">
                        <vs-input v-model="busqueda.cedula" @input="NotasCreditoClientes=[];mostrarBusquedaFail=false;arrayCliente=[];arrayClientePrefacturas=[];selectedTab='saldos';" @keypress.enter="selectedTab='saldos';ObjectClientSelected={};mostrarBusquedaCliente=false;searchData(0)" class="w-full" placeholder="Institucion / Punto de venta" />
                        <vs-button type="filled" style="margin-left:10px;" @click="selectedTab='saldos';NotasCreditoClientes=[];ObjectClientSelected={};arrayClientePrefacturas=[];mostrarBusquedaCliente=false;searchData(0)" icon="search"></vs-button>
                    </div>
                </div>
            </div>
            <div class="vx-col mt-5" v-if="arrayCliente.length > 0 && mostrarBusquedaCliente">
                <vx-card title="Selección de Cliente" class="pb-3" fixed-height="true">
                    <vs-table :max-items="arrayCliente.length" search pagination :data="arrayCliente" v-if="arrayCliente.length > 0">
                        <template slot="header">
                            <vs-chip color="primary">Cantidad: <b>{{ arrayCliente.length }}</b></vs-chip>
                        </template>
                        <template slot="thead">
                            <vs-th>Cliente</vs-th>
                            <vs-th style="width: 10%;">Acciones</vs-th> <!-- Agregado para el botón -->
                        </template>
                        <template slot-scope="{ data }">
                            <vs-tr v-for="(tr, indextr) in data" :key="tr.idInstitucion">
                                <!-- Asegúrate de usar un ID único -->
                                <vs-td>
                                    {{ tr.nombreInstitucion }}<br>
                                </vs-td>
                                <vs-td>
                                    <vs-button @click="ObjectClientSelected=tr; arrayCliente=[]; busqueda.cedula=''; getAllPrefacturas(tr)" class="ml-2 p-3" color="primary" type="filled" icon-pack="feather" icon="icon-check">Seleccionar</vs-button>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>
        </vx-card>
        <vx-card class="mt-5" title="NOTAS INTERCAMBIO/CRÉDITO" v-if="arrayClientePrefacturas.length>0">
            <div v-if="arrayClientePrefacturas.length>0">
                <vs-alert class="my-3" :active="inputValidtipo" color="danger" icon-pack="feather" icon="icon-info">
                    <span v-if="inputValidtipo && inputValid">Hay variaciones en los <b>tipos de venta y descuentos</b> en los documentos.</span>
                    <span v-else-if="inputValidtipo">Hay variaciones en los <b>tipos de venta</b> en los documentos.</span>
                </vs-alert>
            </div>
            <div v-if="arrayClientePrefacturas.length>0">
                <div class="flex justify-center m-5">
                    <!-- Botones para cambiar entre las vistas -->
                    <vs-button class="mx-2" :class="{'active-button': selectedTab === 'saldos'}" type="line" line-position="top" line-origin="left" color="dark" @click="selectedTab = 'saldos'">
                        Convertir Saldos Pendientes a Notas
                    </vs-button>
                    <vs-button class="mx-2" :class="{'active-button': selectedTab === 'desfas'}" type="line" line-position="top" line-origin="left" color="dark" @click="selectedTab = 'desfas'">
                        Convertir desfas a Nota de Crédito
                    </vs-button>
                </div>
                <!-- Vista de "Convertir Saldos a Notas" -->
                <div v-if="selectedTab === 'saldos' && arrayClientePrefacturas.length > 0">
                    <div title="Valores de saldos pendientes se convertirán a notas">
                        <div class="vx-row flex justify-center">
                            <!-- <div class="w-full flex justify-center" v-if="NotasIntercambio && NotasIntercambio.length > 0 && NotasIntercambio[0].intercambio_doc.length > 0">
                            <font style="font-size: 15.5px">&nbsp;Documentos generados:
                                <feather-icon icon="FileTextIcon" class="cursor-pointer ml-4 mr-6 mt-1" :badge="NotasIntercambio[0].intercambio_doc.length" />
                            </font>
                        </div> -->
                            <!-- <div class="w-full flex justify-center" v-if="verNotasIntercambio && NotasIntercambio.length > 0">
                            <vs-table :data="NotasIntercambio[0].intercambio_doc" v-if="NotasIntercambio.length > 0 && NotasIntercambio[0].intercambio_doc.length > 0" style="width: 100%;">
                                <template slot="thead">
                                </template>
                                <template slot-scope="{ data }">
                                    <div class="overflow-y-auto flex">
                                        <vs-tr v-for="(doc, index) in data" :key="index" class="flex">
                                            <vs-td :data="doc">
                                                <vs-button color="primary" @click="getDocumentos(doc)" type="line">
                                                    <i class="fa-regular fa-eye"></i> {{ doc }}
                                                </vs-button>
                                            </vs-td>
                                        </vs-tr>
                                    </div>
                                </template>
                            </vs-table>
                            <div v-else>
                                <vs-alert color="danger" icon-pack="feather" icon="icon-info">
                                    <span>Sin documentos para la devolución.</span>
                                </vs-alert>
                            </div>
                        </div> -->
                        </div>
                        <div class="flex justify-center">
                            <vs-button color="warning" v-if="datosProlipa.length > 0" class="mx-2" @click="checkMarcarLLenar = false; checkBox2 = false; selectedOption = null; SelectCliente = ''; datosFR = []; inputValidtipo && inputValid ? confirmarVariaciontipoDescuento(1, 1) : inputValidtipo ? confirmarVariaciontipo(1, 1) : inputValid ? confirmacionVariacion(1, 1) : crearFacturaReal(1, 1);">
                                Saldo a notas Prolipa
                            </vs-button>
                            <vs-button color="warning" v-if="datosCalmed.length > 0" class="mx-2" @click="checkMarcarLLenar = false; checkBox2 = false; selectedOption = null; SelectCliente = ''; datosFR = []; inputValidtipo && inputValid ? confirmarVariaciontipoDescuento(3, 1) : inputValidtipo ? confirmarVariaciontipo(3, 1) : inputValid ? confirmacionVariacion(3, 1) : crearFacturaReal(3, 1);">
                                Saldo a notas Calmed
                            </vs-button>
                        </div>
                    </div>
                </div>

                <!-- Vista de "Convertir desfas a Nota de Crédito" -->
                <div v-if="selectedTab === 'desfas' && arrayClientePrefacturas.length > 0">
                    <div title="El excedente de facturación se convertirá a nota de crédito">
                        <div v-if="verNotasCredito">
                            <!-- <div class="w-full flex justify-center" v-if="NotasCredito && NotasCredito.length > 0">
                            <font style="font-size: 15.5px">&nbsp;Documentos generados:
                                <feather-icon icon="FileTextIcon" class="cursor-pointer ml-4 mr-6 mt-1" :badge="NotasCredito.length" />
                            </font>
                        </div> -->
                            <!-- <vs-table :data="NotasCredito" v-if="NotasCredito.length>0 && verNotasCredito" style="width: auto;">
                            <template slot-scope="{ data }">
                                <div class="overflow-y-auto flex">
                                    <vs-tr v-for="(doc, index) in data" :key="index" class="flex">
                                        <vs-td :data="doc">
                                            <vs-button color="primary" @click="getDocumentos(doc.ven_codigo )" type="line">
                                                <i class="fa-regular fa-eye"></i> {{ doc.ven_codigo }}
                                            </vs-button>
                                        </vs-td>
                                    </vs-tr>
                                </div>
                            </template>
                        </vs-table>
                        <div v-else>
                            <vs-alert color="danger" icon-pack="feather" icon="icon-info">
                                <span>Sin documentos para la devolución.</span>
                            </vs-alert>
                        </div> -->
                        </div>
                        <div class="vx-row flex justify-center">
                            <vs-button v-if="datosProlipa.length > 0" class="mx-2" color="success" @click="validacionCantNotasCredito=false;validacionNotasCredito=false;checkMarcarLLenar = false; checkBox2 = false; selectedOption = null; SelectCliente = ''; datosFR = []; inputValidtipo && inputValid ? confirmarVariaciontipoDescuento(1, 2) : inputValidtipo ? confirmarVariaciontipo(1, 2) : inputValid ? confirmacionVariacion(1, 2) : crearFacturaReal(1, 2);">
                                Crear nota de Crédito Prolipa
                            </vs-button>
                            <vs-button v-if="datosCalmed.length > 0" class="mx-2" color="success" @click="validacionCantNotasCredito=false;validacionNotasCredito=false;checkMarcarLLenar = false; checkBox2 = false; selectedOption = null; SelectCliente = ''; datosFR = []; inputValidtipo && inputValid ? confirmarVariaciontipoDescuento(3, 2) : inputValidtipo ? confirmarVariaciontipo(3, 2) : inputValid ? confirmacionVariacion(3, 2) : crearFacturaReal(3, 2);">
                                Crear nota de Crédito Calmed
                            </vs-button>
                        </div>
                    </div>
                </div>
                <div v-if="NotasCreditoClientes.length>0">
                    <vs-table max-items="10" pagination search :data="NotasCreditoClientes" v-if="NotasCreditoClientes.length>0" no-data-text="No hay datos disponibles">
                        <template slot="header">
                            <font style="font-size: 15.5px">Cantidad notas:
                                <feather-icon icon="FileTextIcon" class="cursor-pointer ml-4 mr-6 mt-1" :badge="NotasCreditoClientes.length" />
                            </font>
                        </template>
                        <template slot="thead">
                            <vs-th width="300"># Documento</vs-th>
                            <vs-th width="150">Fecha Nota Credito</vs-th>
                            <vs-th width="150">Estado</vs-th>
                            <vs-th width="100">Acciones</vs-th>
                        </template>
                        <template slot-scope="{ data }">
                            <vs-tr v-if="data.length > 0" v-for="(tr, indextr) in data" :key="indextr">
                                <vs-td>
                                    <template v-if="tr.idtipodoc==16">
                                        <b>Fecha creacion: {{ tr.ven_fecha }}</b><br>
                                    </template>
                                    <b class="text-danger">{{tr.idtipodoc==16?'Nota Crédito':'Nota intercambio'}}</b><br />
                                    {{ tr.ven_codigo }}
                                    <br />
                                    <b>{{ tr.id_empresa==1?'Prolipa':tr.id_empresa==3?'Calmed':''}}</b>
                                    <br>Venta: <b v-if="tr.ven_tipo_inst === 'V' || !tr.ven_tipo_inst">Directa</b>
                                    <b v-else>Por Lista</b><br />
                                    <b>Institución: </b>{{ tr.nombreInstitucion }}<br />
                                    <!-- Solo muestra FECHA SRI si existe, sin agregar <br> si no hay valor -->
                                    <template v-if="tr.fecha_sri">
                                        <b class="text-success">FECHA SRI: {{ tr.fecha_sri }}</b><br>
                                    </template>

                                    <!-- Solo muestra DOCUMENTO SRI si existe, sin agregar <br> si no hay valor -->
                                    <template v-if="tr.documento_sri">
                                        <b class="text-success">DOCUMENTO SRI: {{ tr.documento_sri }}</b><br>
                                    </template>
                                </vs-td>
                                <vs-td v-if="tr.idtipodoc==16">
                                    <p class="font-bold">Fecha:</p>
                                    <span>{{ tr.fecha_notaCredito }}</span>
                                </vs-td>
                                <vs-td v-else>
                                    <p class="font-bold">Fecha:</p>
                                    <span>{{ tr.ven_fecha }}</span>
                                </vs-td>
                                <vs-td>
                                    <span v-if="tr.idPuntoventa"><b>Grupo:</b> {{ tr.idPuntoventa }}</span><br />
                                    <vs-chip v-if="tr.est_ven_codigo === 14" color="danger">PENDIENTE DE ASOCIAR SRI</vs-chip>
                                    <vs-chip v-if="tr.est_ven_codigo === 15" color="LimeGreen">ASOCIADO SRI</vs-chip>
                                    <vs-chip v-else-if="tr.est_ven_codigo === 13" color="dark">Intercambio</vs-chip>
                                </vs-td>
                                <vs-td>
                                    <vs-dropdown vs-custom-content vs-trigger-click title="Opciones">
                                        <vs-button class="a-icons" href.prevent icon="more_vert" type="border"></vs-button>
                                        <vs-dropdown-menu style="width: 250px" class="cursor">
                                            <vs-dropdown-item>
                                                <vs-button color="#28C76F" type="line" class="w-full" @click="getDocumentos(tr.ven_codigo, tr.id_empresa)">Imprimir</vs-button>
                                                <vs-button v-if="tr.idtipodoc==16" color="danger" type="line" class="items-center mt-4" @click="popupSRI = true; itemSeleccionado = tr;">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-pencil-bolt">
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                        <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" />
                                                        <path d="M13.5 6.5l4 4" />
                                                        <path d="M19 16l-2 3h4l-2 3" />
                                                    </svg>
                                                    Añadir datos SRI Nota de Crédito
                                                </vs-button>
                                            </vs-dropdown-item>
                                        </vs-dropdown-menu>
                                    </vs-dropdown>
                                </vs-td>
                            </vs-tr>
                            <vs-tr v-else>
                                <vs-td colspan="7" class="text-center">No hay datos disponibles.</vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </div>
        </vx-card>
        <vs-popup :active.sync="popupSRI" v-if="popupSRI" title="Asociar datos:">
            <DatosSRINotasCredito v-if="popupSRI" :ItemSeleccionado="itemSeleccionado" @documento-no-seleccionado="documentoNoSeleccionado" @actualizado-datos="documentoActualizado" />
        </vs-popup>
        <vx-card :title="'Reporte de '+ObjectClientSelected.nombreInstitucion" class="mt-5" v-if="arrayClientePrefacturas.length>0">
            <div v-if="arrayClientePrefacturas.length>0">
                <vs-alert :active="inputValid" color="danger" icon-pack="feather" icon="icon-info">
                    <span>Hay variaciones en los valores de <b>descuentos</b> en los documentos. {{ ven_desc_por_unique }}</span>
                </vs-alert>
                
                <vs-table max-items="10" pagination search :data="arrayClientePrefacturas" v-if="arrayClientePrefacturas.length>0" no-data-text="No hay datos disponibles">
                    <template slot="header">
                        <vs-chip color="primary">
                            Cantidad: <b>{{ arrayClientePrefacturas ? arrayClientePrefacturas.length : 0 }}</b>
                        </vs-chip>
                        <vs-button v-if="datosProlipa.length>0" class="mx-2" @click="checkMarcarLLenar= false;checkBox2= false;selectedOption=null;SelectCliente='';datosFR=[];inputValid?confirmacionVariacion(1):crearFacturaReal(1);">Crear Fact. Real en Prolipa</vs-button>
                        <vs-button v-if="datosCalmed.length>0" @click="checkMarcarLLenar= false;checkBox2= false;selectedOption=null;SelectCliente='';datosFR=[];inputValid?confirmacionVariacion(3):crearFacturaReal(3);">Crear Fact. Real en Calmed</vs-button>
                    </template>
                    <template slot="thead">
                        <vs-th width="300"># Documento</vs-th>
                        <vs-th width="100">Empresa remitente</vs-th>
                        <vs-th width="900">Información documento</vs-th>
                        <vs-th width="200">Estado</vs-th>
                        <vs-th width="100">Acciones</vs-th>
                    </template>
                    <template slot-scope="{ data }">
                        <vs-tr v-if="data.length > 0" v-for="(tr, indextr) in data" :key="indextr">
                            <vs-td>
                                {{ tr.ven_codigo }}
                                <br />Venta: <b v-if="tr.ven_tipo_inst === 'V' || !tr.ven_tipo_inst">Directa</b>
                                <b v-else>Por Lista</b>
                                <br /><b>Facturador: </b>{{ tr.responsable }}
                                <span v-if="tr.ven_tipo_inst === 'V' || !tr.ven_tipo_inst">
                                    <br /><b>Asesor: </b>{{ tr.asesor }}
                                </span>
                                <span v-if="tr.ven_idproforma">
                                    <br /><b>Pre-Proforma: </b>{{ tr.ven_idproforma }}
                                </span>
                            </vs-td>
                            <vs-td>{{ tr.descripcion_corta}} </vs-td>
                            <vs-td>
                                <b>Cliente:</b> <span v-if="tr.clienteUsuario">{{ tr.clienteUsuario }}</span><br>
                                <b>Institución:</b> <span>{{ tr.clienteInstitucion }}</span><br />
                                <b>Período escolar:</b> <span>{{ tr.periodoescolar }}</span>
                                <p class="font-bold">Fecha:</p>
                                <span>{{ tr.ven_fecha }}</span>
                            </vs-td>
                            <vs-td>
                                <span v-if="tr.idPuntoventa"><b>Grupo:</b> {{ tr.idPuntoventa }} </span><br />
                                <vs-chip v-if="tr.est_ven_codigo === 1" color="LimeGreen">Despachado</vs-chip>
                                <vs-chip v-else-if="tr.est_ven_codigo === 2" color="warning" type="gradient">Pendiente de despacho</vs-chip>
                                <vs-chip v-else-if="tr.est_ven_codigo === 3" color="LightCoral">Anulada</vs-chip>
                                <vs-chip v-else-if="tr.est_ven_codigo === 12" color="Gold">Preparada</vs-chip>
                                <vs-chip v-else-if="tr.est_ven_codigo === 11" color="Orange">Pendiente Excluido</vs-chip>
                                <vs-chip v-else-if="tr.est_ven_codigo === 10" color="Violet">Aprobada</vs-chip>
                            </vs-td>
                            <vs-td>
                                <vs-dropdown vs-custom-content vs-trigger-click title="Opciones">
                                    <vs-button class="a-icons" href.prevent icon="more_vert" type="border"></vs-button>
                                    <vs-dropdown-menu style="width: 250px" class="cursor">
                                        <vs-dropdown-item>
                                            <vs-button color="#28C76F" type="line" class="w-full" @click="getDocumentos(tr.ven_codigo,tr.id_empresa)">Imprimir</vs-button>
                                        </vs-dropdown-item>
                                    </vs-dropdown-menu>
                                </vs-dropdown>
                            </vs-td>
                        </vs-tr>
                        <vs-tr v-else>
                            <vs-td colspan="7" class="text-center">No hay datos disponibles.</vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
            <vs-popup fullscreen :active.sync="popupFR" :title="`Reporte ${ObjectClientSelected.nombreInstitucion} (${empresa})`" @close="getAllPrefacturas(datacliente);">
                <div class="p-4 bg-white shadow-lg rounded-lg">
                    <div class="w-full">
                        <div class="flex items-center mb-2">
                            <p class="text-gray-700">Institución / Punto de venta:</p>
                            <p class="ml-2 text-lg text-blue-600 font-bold">{{ ObjectClientSelected.nombreInstitucion }}</p>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <!-- Primera columna -->
                            <div>
                                <div class="flex items-center mb-2">
                                    <p class="text-gray-600">Fecha: <span class="font-semibold">{{ fechaActual }}</span></p>
                                </div>
                                <div class="flex items-center mb-2">
                                    <p class="text-gray-600">Empresa: <span class="font-semibold">{{ empresa }}</span></p>
                                </div>

                                <div class="flex flex-col mt-2">
                                    <div class="flex items-center mb-2">
                                        <div v-if="!clientesVariacion">
                                            <div class="mb-2">
                                                <p class="text-gray-600">Cliente: <span class="font-semibold">{{ dataclienteunique.nombreCliente }}</span></p>
                                            </div>
                                            <div>
                                                <p class="text-gray-600">RUC/CI: <span class="font-semibold">{{ dataclienteunique.ruc_cliente }}</span></p>
                                            </div>
                                        </div>
                                        <div class="w-full" v-else>
                                            <div class="flex items-center w-full">
                                                <p class="font-semibold">Selección de cliente:</p>
                                                <v-select :options="clientesreporte" :reduce="clientesreporte => clientesreporte" label="clienteUsuario" class="w-full h-100 ml-2" placeholder="--Seleccione--" v-model="SelectCliente" @input="validarSeleccionCliente()" />
                                            </div>
                                            <div class="w-full mt-2" v-if="!SelectCliente">
                                                <vs-alert color="danger" icon-pack="feather" icon="icon-info">
                                                    <span>Seleccione <b>el cliente</b>.</span>
                                                </vs-alert>
                                            </div>
                                            <div v-if="SelectCliente" class="w-full mt-2">
                                                <div class="mb-2">
                                                    <p class="text-gray-600">Cliente: <span class="font-semibold">{{ dataclienteunique.nombreCliente }}</span></p>
                                                </div>
                                                <div>
                                                    <p class="text-gray-600">RUC/CI: <span class="font-semibold">{{ dataclienteunique.ruc_cliente }}</span></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex items-center mb-2">
                                        <p class="text-gray-600">Período escolar: <span class="font-semibold">{{ periodoSelect.descripcion }}</span></p>
                                    </div>
                                </div>
                            </div>
                            <!-- Segunda columna -->
                            <div class="w-full rounded-lg p-4">
                                <div class="flex justify-center mb-3">
                                    <span class="mx-4">Factura Real #: {{codigo}}</span>
                                </div>
                                <div class="flex items-center" style="width: 90%">
                                    <div class="flex w-full md:w-full items-center">
                                        <span class="flex items-center mt-3">
                                            <vs-checkbox class="ml-5 " color="success" v-model="checkBox2" @input="quitarvalidacion"></vs-checkbox>Permitir Facturar más de lo despachado.
                                        </span>
                                        <span class="flex items-center mt-3">
                                            <vs-checkbox class="ml-5 " color="success" v-model="checkMarcarLLenar"></vs-checkbox>Llenar y seleccionar.
                                        </span>
                                    </div>
                                </div>
                                <div class="flex w-full md:w-full items-center mr-5 mt-3">
                                    <span class="mx-1">Filtrar: </span>
                                    <v-select class="w-full" style="width: 200px;" v-model="selectedOption" :options="options" :reduce="options => options.value" @change="applyFilters" @input="applyFilters" placeholder="Selecciona un filtro"></v-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="w-full">
                            <div class="flex items-center mb-2">
                                <p class="text-gray-700">Institución / Punto de venta:</p>
                                <p class="ml-2 text-lg text-blue-600 font-bold">{{ ObjectClientSelected.nombreInstitucion }}</p>
                            </div>
                            <div class="w-full">
                                <div class="w-1/2"> 
                                    <div class="flex items-center mb-2">
                                        <p class="text-gray-600">Fecha: <span class="font-semibold">{{ fechaActual }}</span></p>
                                    </div>
                                </div>
                                <div class="w-1/2">
                                    <div class="flex items-center mb-2">
                                        <p class="text-gray-600">Empresa: <span class="font-semibold">{{ empresa }}</span></p>
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-col mt-2">
                                <div class="flex items-center mb-2">
                                    <div v-if="!clientesVariacion">
                                        <div class="mb-2">
                                            <p class="text-gray-600">Cliente: <span class="font-semibold">{{ dataclienteunique.nombreCliente }}</span></p>
                                        </div>
                                        <div>
                                        <p class="text-gray-600">RUC/CI: <span class="font-semibold">{{ dataclienteunique.ruc_cliente }}</span></p>
                                        </div>
                                    </div>
                                    <div class="w-full" v-else>
                                        <div class="w-1/2 justify-center flex">
                                            <p class="font-semibold">Selección de cliente:</p>
                                            <v-select :options="clientesreporte" :reduce="clientesreporte => clientesreporte" label="clienteUsuario" class="w-full h-100" placeholder="--Seleccione--" v-model="SelectCliente" @input="validarSeleccionCliente()" />
                                        </div>
                                        <div class="w-1/2" v-if="!SelectCliente">
                                            <vs-alert color="danger" icon-pack="feather" icon="icon-info">
                                                <span>Seleccione <b>el cliente</b>.</span>
                                            </vs-alert>
                                        </div>
                                        <div v-if="SelectCliente" class="w-f1/2 mt-2"> 
                                            <div class="mb-2">
                                                <p class="text-gray-600">Cliente: <span class="font-semibold">{{ dataclienteunique.nombreCliente }}</span></p>
                                            </div>
                                            <div>
                                                <p class="text-gray-600">RUC/CI: <span class="font-semibold">{{ dataclienteunique.ruc_cliente }}</span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex items-center mb-2">
                                    <p class="text-gray-600">Período escolar: <span class="font-semibold">{{ periodoSelect.descripcion }}</span></p>
                                </div>
                            </div>
                        </div>
                        <vs-divider></vs-divider>     
                        <div class="flex justify-center mb-3">
                            <span class="mx-4">Factura Real #: {{codigo}}</span>
                        </div>
                        <div class="flex items-center" style="width: 90%">
                            <div class="fle x w-1/2 md:w-full items-center">
                                <vs-checkbox class="ml-5" color="success" v-model="checkBox2" @input="quitarvalidacion">Permitir Facturar más de lo despachado.</vs-checkbox>
                                <vs-checkbox class="ml-5 mt-3" color="success" v-model="checkMarcarLLenar">Llenar y seleccionar.</vs-checkbox>
                            </div>
                            <div class="flex w-1/2 md:w-full items-center mr-5 ">
                                <span class="mx-1">Filtrar: </span>
                                <v-select class="w-full" style="width: 200px;" v-model="selectedOption" :options="options" :reduce="options => options.value" @change="applyFilters" @input="applyFilters" placeholder="Selecciona un filtro"></v-select>
                            </div>
                        </div> -->
                    <div v-if="datosAllFR" class="table-container mt-5">
                        <vs-table class="mt-2" :data="datosAllFR" :max-items="20" search no-data-text="No hay datos disponibles">
                            <template slot="header">
                                <vs-chip color="#49218a">Cantidad: <b> {{ datosAllFR.length }}</b></vs-chip>
                                <p class="mx-3"><b>Total ítems seleccionados: {{ checkedItemCount }}</b></p>
                            </template>
                            <template slot="thead">
                                <vs-th width="20">
                                    <vs-checkbox color="dark" v-model="selectAll" @change="toggleAll"></vs-checkbox>
                                </vs-th>
                                <vs-th width="20">
                                    #
                                </vs-th>
                                <vs-th sort-key="pro_codigo">Codigo</vs-th>
                                <vs-th sort-key="nombre">Producto</vs-th>
                                <vs-th>Cantidad en Prefacturas</vs-th>
                                <vs-th>Cantidad devuelta</vs-th>
                                <vs-th>Cantidad ya Facturada</vs-th>
                                <vs-th>Cantidad Nota Crédito</vs-th>
                                <vs-th>Cantidad Facturada - Nota Crédito</vs-th>
                                <vs-th>Cantidad disponible a Facturar </vs-th>
                                <vs-th>Precio * Unidad</vs-th>
                                <vs-th>Precio * Cantidad</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :key="k" v-for="(tr, k) in data" :state="(tr.det_ven_cantidad - tr.det_ven_dev) < tr.cantidad_facturada-tr.cantidad_nota_credito  ? 'danger':null">
                                    <vs-td>
                                        <vs-checkbox color="dark" v-model="tr.check_real_facturar" :disabled="tr.check_cantidades"></vs-checkbox>
                                    </vs-td>
                                    <vs-td>
                                        <span>{{k+1}}</span>
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.pro_codigo}}
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.nombre }}
                                    </vs-td>
                                    <vs-td>{{ tr.det_ven_cantidad}}</vs-td>
                                    <vs-td>{{ tr.det_ven_dev }}</vs-td>
                                    <vs-td>{{ tr.cantidad_facturada }}</vs-td>
                                    <vs-td>{{ tr.cantidad_nota_credito }}</vs-td>
                                    <vs-td>{{ tr.cantidad_facturada - tr.cantidad_nota_credito }}</vs-td>
                                    <vs-td>
                                        <vs-input :disabled="tr.check_cantidades" v-model="tr.cantidad_real_facturar" :min="0" :max="(tr.det_ven_cantidad - tr.det_ven_dev) - (tr.cantidad_facturada - tr.cantidad_nota_credito)" @input="validateInput(tr)" /><br>
                                        <span v-if="tr.cantidad_facturada - tr.cantidad_nota_credito > tr.det_ven_cantidad - tr.det_ven_dev" class="text-danger font-bold">Cantidad facturada excedida</span>
                                    </vs-td>
                                    <vs-td> {{ tr.det_ven_valor_u }} </vs-td>
                                    <vs-td style="text-align: right;"> {{ (tr.det_ven_valor_u * tr.cantidad_real_facturar).toFixed(2) }} </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                    <vs-divider></vs-divider>
                    <div class="w-full flex justify-between mt-3">
                        <div class="checked-count w-1/2">
                            <p><b>Total ítems seleccionados: {{ checkedItemCount }}</b></p>
                        </div>
                        <div class="w-1/2">
                            <table style="width: 100%; text-align: right;">
                                <tr>
                                    <td>
                                        <p><b>SUBTOTAL $</b></p>
                                    </td>
                                    <td>
                                        <p><b>{{ subtotal.toFixed(2) }}</b></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="flex justify-end items-center justify-items-center">
                                            <p><b>DESCUENTO </b></p>
                                            <span v-if="descuentoVariacion" class="flex items-center">
                                                <vs-input max="100" min="0" v-model="inputDescuento" type="number" placeholder="Descuento" style="width: 100px;" class="mx-2" />
                                                <p><b> %</b></p>
                                            </span>
                                            <span v-else>
                                                <p><b class="mx-2"> {{ ven_desc_por_unique[0] }} %</b></p>
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <p><b>{{ descuento.toFixed(2) }}</b></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p><b>(SUBTOTAL - DESCUENTO) $</b></p>
                                    </td>
                                    <td>
                                        <p><b>{{ subtotalDescuento.toFixed(2) }}</b></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p><b>IVA $</b></p>
                                    </td>
                                    <td>
                                        <p><b>{{ iva.toFixed(2) }}</b></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p><b>TRANSPORTE $</b></p>
                                    </td>
                                    <td>
                                        <p><b>{{ transporte.toFixed(2) }}</b></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p><b>TOTAL $</b></p>
                                    </td>
                                    <td>
                                        <p><b>{{ total.toFixed(2) }}</b></p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="flex justify-center mt-5">
                        <vs-button class="vs-con-loading__container" color="success" type="relief" @click="guardarDatos" :disabled="isLoading">
                            <span v-if="isLoading">GUARDANDO...</span>
                            <span v-else>Guardar</span>
                        </vs-button>
                        <!-- <vs-button @click="guardarDatos" color="success" type="relief">Guardar</vs-button> -->
                    </div>
                </div>
            </vs-popup>
            <vs-popup title="PREFACTURA a NOTA" fullscreen :active.sync="popupPrefacturaANotas" @close="isLoading?handleCloseAbono():getAllPrefacturas(datacliente);" :class="{ 'hide-close': isLoading }">
                <div class="p-4 bg-white shadow-lg rounded-lg">
                    <div class="w-full">
                        <div class="flex items-center mb-2">
                            <p class="text-gray-700">Institución / Punto de venta:</p>
                            <p class="ml-2 text-lg text-blue-600 font-bold">{{ ObjectClientSelected.nombreInstitucion }}</p>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <!-- Primera columna -->
                            <div>
                                <div class="flex items-center mb-2">
                                    <p class="text-gray-600">Fecha: <span class="font-semibold">{{ fechaActual }}</span></p>
                                </div>
                                <div class="flex items-center mb-2">
                                    <p class="text-gray-600">Empresa: <span class="font-semibold">{{ empresa }}</span></p>
                                </div>

                                <div class="flex flex-col mt-2">
                                    <div class="flex items-center mb-2">
                                        <div v-if="!clientesVariacion">
                                            <div class="mb-2">
                                                <p class="text-gray-600">Cliente: <span class="font-semibold">{{ dataclienteunique.nombreCliente }}</span></p>
                                            </div>
                                            <div>
                                                <p class="text-gray-600">RUC/CI: <span class="font-semibold">{{ dataclienteunique.ruc_cliente }}</span></p>
                                            </div>
                                        </div>
                                        <div class="w-full" v-else>
                                            <div class="flex items-center w-full">
                                                <p class="font-semibold">Selección de cliente:</p>
                                                <v-select :options="clientesreporte" :reduce="clientesreporte => clientesreporte" label="clienteUsuario" class="w-full h-100 ml-2" placeholder="--Seleccione--" v-model="SelectCliente" @input="validarSeleccionCliente()" />
                                            </div>
                                            <div class="w-full mt-2" v-if="!SelectCliente">
                                                <vs-alert color="danger" icon-pack="feather" icon="icon-info">
                                                    <span>Seleccione <b>el cliente</b>.</span>
                                                </vs-alert>
                                            </div>
                                            <div v-if="SelectCliente" class="w-full mt-2">
                                                <div class="mb-2">
                                                    <p class="text-gray-600">Cliente: <span class="font-semibold">{{ dataclienteunique.nombreCliente }}</span></p>
                                                </div>
                                                <div>
                                                    <p class="text-gray-600">RUC/CI: <span class="font-semibold">{{ dataclienteunique.ruc_cliente }}</span></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex items-center mb-2">
                                        <p class="text-gray-600">Período escolar: <span class="font-semibold">{{ periodoSelect.descripcion }}</span></p>
                                    </div>
                                </div>
                            </div>
                            <!-- Segunda columna -->
                            <div class="w-full rounded-lg p-4">
                                <div class="flex justify-center mb-3">
                                    <span class="mx-4 text-danger"><b>Nota #: {{codigo}}</b></span> <br>
                                </div>
                                <div class="flex justify-center mb-3">
                                    <h4 class="text-danger font-bold">{{ tipo_ven_codigo==1 ?"Venta Directa":tipo_ven_codigo==2?"Venta Lista":'' }}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="datosAllFR" class="table-container mt-5">
                        <vs-table class="mt-2" :data="datosAllFR" :max-items="20" search no-data-text="No hay datos disponibles">
                            <template slot="header">
                                <vs-chip color="red">Cantidad: <b> {{ datosAllFR.length }}</b></vs-chip>
                            </template>
                            <template slot="thead">
                                <vs-th width="20">
                                </vs-th>
                                <vs-th width="20">
                                    #
                                </vs-th>
                                <vs-th sort-key="pro_codigo">Codigo</vs-th>
                                <vs-th sort-key="nombre">Producto</vs-th>
                                <vs-th>Cantidad en Prefacturas</vs-th>
                                <vs-th>Cantidad devuelta</vs-th>
                                <vs-th>Cantidad ya Facturada</vs-th>
                                <vs-th>Cantidad Nota Credito</vs-th>
                                <vs-th style="color: red;">Cantidad a Nota</vs-th>
                                <vs-th>Precio * Unidad</vs-th>
                                <vs-th>Precio * Cantidad</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :key="k" v-for="(tr, k) in data">
                                    <vs-td>
                                        <vs-checkbox color="red" v-model="tr.check_real_facturar" disabled></vs-checkbox>
                                    </vs-td>
                                    <vs-td>
                                        <span>{{k+1}}</span>
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.pro_codigo}}
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.nombre }}
                                    </vs-td>
                                    <vs-td>{{ tr.det_ven_cantidad}}</vs-td>
                                    <vs-td>{{ tr.det_ven_dev }}</vs-td>
                                    <vs-td>{{ tr.cantidad_facturada }}</vs-td>
                                    <vs-td>{{ tr.cantidad_nota_credito }}</vs-td>
                                    <vs-td>{{ tr.cantidad_real_facturar }}</vs-td>
                                    <vs-td> {{ tr.det_ven_valor_u }} </vs-td>
                                    <vs-td style="text-align: right;"> {{ (tr.det_ven_valor_u * tr.cantidad_real_facturar).toFixed(2) }} </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                    <vs-divider></vs-divider>
                    <div class="w-full flex justify-end mt-3">
                        <div class="w-1/2">
                            <table style="width: 100%; text-align: right;">
                                <tr>
                                    <td>
                                        <p><b>SUBTOTAL $</b></p>
                                    </td>
                                    <td>
                                        <p><b>{{ subtotal.toFixed(2) }}</b></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="flex justify-end items-center justify-items-center">
                                            <p><b>DESCUENTO </b></p>
                                            <span v-if="descuentoVariacion" class="flex items-center">
                                                <vs-input max="100" min="0" v-model="inputDescuento" type="number" placeholder="Descuento" style="width: 100px;" class="mx-2" />
                                                <p><b> %</b></p>
                                            </span>
                                            <span v-else>
                                                <p><b class="mx-2"> {{ ven_desc_por_unique[0] }} %</b></p>
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <p><b>{{ descuento.toFixed(2) }}</b></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p><b>(SUBTOTAL - DESCUENTO) $</b></p>
                                    </td>
                                    <td>
                                        <p><b>{{ subtotalDescuento.toFixed(2) }}</b></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p><b>IVA $</b></p>
                                    </td>
                                    <td>
                                        <p><b>{{ iva.toFixed(2) }}</b></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p><b>TRANSPORTE $</b></p>
                                    </td>
                                    <td>
                                        <p><b>{{ transporte.toFixed(2) }}</b></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p><b>TOTAL $</b></p>
                                    </td>
                                    <td>
                                        <p><b>{{ total.toFixed(2) }}</b></p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="flex justify-center mt-5">
                        <vs-button class="vs-con-loading__container" color="danger" type="relief" @click="guardarDatosNotas" :disabled="isLoading">
                            <span v-if="isLoading">GUARDANDO...</span>
                            <span v-else>Guardar</span>
                        </vs-button>
                        <!-- <vs-button @click="guardarDatos" color="success" type="relief">Guardar</vs-button> -->
                    </div>
                </div>
            </vs-popup>
            <vs-prompt title="Seleccione el tipo de venta" @cancel="close" cancelText="Cancelar" acceptText="Generar" @accept="acceptAlert" @close="close" :active.sync="activePrompt">
                <div class="con-exemple-prompt">
                    <p class="mt-2">Seleccione el Tipo de venta</p>
                    <v-select :options="optionsVenta" :reduce="optionsVenta => optionsVenta.value" label="label" class="w-full" v-model="tipo_ven_codigo" />
                </div>
            </vs-prompt>
            <vs-popup fullscreen v-if="popupDocumento" :title="'Detalle:'" :active.sync="popupDocumento" class="popopPadre">
                <div v-if="popupDocumento">
                    <documentoVenta :DocumentoVenta="DocumentoVenta[0]" :DocumentoDetalleVenta="DocumentoDetalleVenta" />
                </div>
            </vs-popup>
            <vs-popup title="NOTA DE CRÉDITO" fullscreen :active.sync="popupNotaDeCredito" @close="isLoading?handleCloseAbono():getAllPrefacturas(datacliente);" :class="{ 'hide-close': isLoading }">
                <div class="p-4 bg-white shadow-lg rounded-lg">
                    <div class="w-full">
                        <div class="flex items-center mb-2">
                            <p class="text-gray-700">Institución / Punto de venta:</p>
                            <p class="ml-2 text-lg text-blue-600 font-bold">{{ ObjectClientSelected.nombreInstitucion }}</p>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <div class="flex items-center mb-2">
                                    <!-- <p class="text-gray-600">Fecha: <span class="font-semibold">{{ fechaActual }}</span></p> -->
                                    <p class="text-gray-600 mr-4">Fecha:</p>
                                    <flat-pickr :config="configdateTimePicker" v-model="fechaActual" placeholder="Fecha " style="display: inline-block;width: 70%" />
                                </div>
                                <div class="flex items-center mb-2">
                                    <p class="text-gray-600">Empresa: <span class="font-semibold">{{ empresa }}</span></p>
                                </div>

                                <div class="flex flex-col mt-2">
                                    <div class="flex items-center mb-2">
                                        <div v-if="!clientesVariacion">
                                            <div class="mb-2">
                                                <p class="text-gray-600">Cliente: <span class="font-semibold">{{ dataclienteunique.nombreCliente }}</span></p>
                                            </div>
                                            <div>
                                                <p class="text-gray-600">RUC/CI: <span class="font-semibold">{{ dataclienteunique.ruc_cliente }}</span></p>
                                            </div>
                                        </div>
                                        <div class="w-full" v-else>
                                            <div class="flex items-center w-full">
                                                <p class="font-semibold">Selección de cliente:</p>
                                                <v-select :options="clientesreporte" :reduce="clientesreporte => clientesreporte" label="clienteUsuario" class="w-full h-100 ml-2" placeholder="--Seleccione--" v-model="SelectCliente" @input="validarSeleccionCliente()" />
                                            </div>
                                            <div class="w-full mt-2" v-if="!SelectCliente">
                                                <vs-alert color="danger" icon-pack="feather" icon="icon-info">
                                                    <span>Seleccione <b>el cliente</b>.</span>
                                                </vs-alert>
                                            </div>
                                            <div v-if="SelectCliente" class="w-full mt-2">
                                                <div class="mb-2">
                                                    <p class="text-gray-600">Cliente: <span class="font-semibold">{{ dataclienteunique.nombreCliente }}</span></p>
                                                </div>
                                                <div>
                                                    <p class="text-gray-600">RUC/CI: <span class="font-semibold">{{ dataclienteunique.ruc_cliente }}</span></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex items-center mb-2">
                                        <p class="text-gray-600">Período escolar: <span class="font-semibold">{{ periodoSelect.descripcion }}</span></p>
                                    </div>
                                </div>
                            </div>
                            <div class="w-full rounded-lg p-4">
                                <div class="flex justify-center mb-3">
                                    <h4 class="mx-4 text-danger"><b>Nota Crédito #: {{codigo}}</b></h4> <br>
                                </div>
                                <!-- <div class="flex justify-center mb-3">                                                                          
                                    <h4 class="text-danger font-bold">{{ tipo_ven_codigo==1 ?"Venta Directa":tipo_ven_codigo==2?"Venta Lista":'' }}</h4>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-center items-center mt-5">
                        <h5>Configuracion:</h5>
                        <div class="items-center">
                            <vs-checkbox color="red" v-model="validacionNotasCredito" @input="ValidarNotas">Excluir items</vs-checkbox>
                            <vs-checkbox color="red" v-model="validacionCantNotasCredito">Cambiar cantidades a convertir de los items</vs-checkbox>
                        </div>
                    </div>
                    <div v-if="datosAllFR" class="table-container mt-5">
                        <vs-table class="mt-2" :data="datosAllFR" :max-items="20" search no-data-text="No hay datos disponibles">
                            <template slot="header">
                                <vs-chip color="red">Cantidad: <b> {{ datosAllFR.length }}</b></vs-chip>
                                <p><b>Total ítems seleccionados: {{ checkedItemCount }}</b></p>
                            </template>
                            <template slot="thead">
                                <vs-th width="20">
                                </vs-th>
                                <vs-th width="20">
                                    #
                                </vs-th>
                                <vs-th sort-key="pro_codigo">Codigo</vs-th>
                                <vs-th sort-key="nombre">Producto</vs-th>
                                <vs-th>Cantidad en Prefacturas</vs-th>
                                <vs-th>Cantidad devuelta</vs-th>
                                <vs-th>Cantidad ya Facturada</vs-th>
                                <vs-th>Cantidad en Nota Crédito</vs-th>
                                <vs-th style="color: red;">Cantidad convertir a Nota Crédito</vs-th>
                                <vs-th>Precio * Unidad</vs-th>
                                <vs-th>Precio * Cantidad</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :key="k" v-for="(tr, k) in data">
                                    <vs-td>
                                        <vs-checkbox color="red" v-model="tr.check_real_facturar" :disabled="!validacionNotasCredito"></vs-checkbox>
                                    </vs-td>
                                    <vs-td>
                                        <span>{{k+1}}</span>
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.pro_codigo}}
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.nombre }}
                                    </vs-td>
                                    <vs-td>{{ tr.det_ven_cantidad}}</vs-td>
                                    <vs-td>{{ tr.det_ven_dev }}</vs-td>
                                    <vs-td>{{ tr.cantidad_facturada }}</vs-td>
                                    <vs-td>{{ tr.cantidad_nota_credito }}</vs-td>
                                    <vs-td v-if="validacionCantNotasCredito">
                                        <vs-input :disabled="!validacionCantNotasCredito" v-model="tr.cantidad_real_facturar" :min="0" :max="(tr.det_ven_cantidad - tr.det_ven_dev) - (tr.cantidad_facturada - tr.cantidad_nota_credito)" @input="validateInputNota(tr)" /><br>
                                    </vs-td>
                                    <vs-td v-else>{{ tr.cantidad_real_facturar }}</vs-td>
                                    <vs-td> {{ tr.det_ven_valor_u }} </vs-td>
                                    <vs-td style="text-align: right;"> {{ (tr.det_ven_valor_u * tr.cantidad_real_facturar).toFixed(2) }} </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                    <vs-divider></vs-divider>
                    <div class="w-full flex justify-end mt-3">
                        <div class="checked-count w-1/2">
                            <p><b>Total ítems seleccionados: {{ checkedItemCount }}</b></p>
                        </div>
                        <div class="w-1/2">
                            <table style="width: 100%; text-align: right;">
                                <tr>
                                    <td>
                                        <p><b>SUBTOTAL $</b></p>
                                    </td>
                                    <td>
                                        <p><b>{{ subtotal.toFixed(2) }}</b></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="flex justify-end items-center justify-items-center">
                                            <p><b>DESCUENTO </b></p>
                                            <span v-if="descuentoVariacion" class="flex items-center">
                                                <vs-input max="100" min="0" v-model="inputDescuento" type="number" placeholder="Descuento" style="width: 100px;" class="mx-2" />
                                                <p><b> %</b></p>
                                            </span>
                                            <span v-else>
                                                <p><b class="mx-2"> {{ ven_desc_por_unique[0] }} %</b></p>
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <p><b>{{ descuento.toFixed(2) }}</b></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p><b>(SUBTOTAL - DESCUENTO) $</b></p>
                                    </td>
                                    <td>
                                        <p><b>{{ subtotalDescuento.toFixed(2) }}</b></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p><b>IVA $</b></p>
                                    </td>
                                    <td>
                                        <p><b>{{ iva.toFixed(2) }}</b></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p><b>TRANSPORTE $</b></p>
                                    </td>
                                    <td>
                                        <p><b>{{ transporte.toFixed(2) }}</b></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p><b>TOTAL $</b></p>
                                    </td>
                                    <td>
                                        <p><b>{{ total.toFixed(2) }}</b></p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="flex justify-center mt-5">
                        <vs-button class="vs-con-loading__container" color="danger" type="relief" @click="guardarDatosNotaCredito" :disabled="isLoading">
                            <span v-if="isLoading">GUARDANDO...</span>
                            <span v-else>Guardar</span>
                        </vs-button>
                    </div>
                </div>
            </vs-popup>
        </vx-card>
        <vs-popup v-model="popupVisible" title="Productos sin stock suficiente" :active.sync="popupVisible">
            <div v-if="productosNoDisponibles.length">
                <vs-table class="mt-2" :data="productosNoDisponibles" :max-items="20" stripe no-data-text="No hay datos disponibles" style="border-radius: 8px; box-shadow: 0 4px 10px rgba(0,0,0,0.1);">
                    <template slot="thead">
                        <vs-th sort-key="pro_codigo" style="background-color: #f7f7f7; text-align: center; font-weight: bold;">Código</vs-th>
                        <vs-th sort-key="cantidad_solicitada" style="background-color: #f7f7f7; text-align: center; font-weight: bold;">Cantidad solicitada</vs-th>
                        <vs-th sort-key="stock_disponible" style="background-color: #f7f7f7; text-align: center; font-weight: bold;">Stock disponible</vs-th>
                    </template>
                    <template slot-scope="{ data }">
                        <vs-tr :key="k" v-for="(tr, k) in data">
                            <vs-td style="text-align: center; padding: 8px; font-size: 14px;">{{ tr.codigo }}</vs-td>
                            <vs-td style="text-align: center; padding: 8px; font-size: 14px;">{{ tr.cantidad_solicitada }}</vs-td>
                            <vs-td style="text-align: center; padding: 8px; font-size: 14px;">
                                <span :style="{ color: tr.stock_disponible < tr.cantidad_solicitada ? 'red' : 'green' }">
                                    {{ tr.stock_disponible }}
                                </span>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
            <vs-alert v-else type="error" dense>¡No se encontraron productos sin stock!</vs-alert>
            <div class="flex justify-center mt-4">
                <vs-button @click="popupVisible = false" color="primary">Cerrar</vs-button>
            </div>
        </vs-popup>

    </div>
</div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import vSelect from "vue-select";
import {
    metadata
} from "core-js/fn/reflect";
import flatPickr from 'vue-flatpickr-component';
const documentoVenta = () => import('@/views/pedidos2/pedidos/proforma/documentoVenta.vue');
const DatosSRINotasCredito = () => import('@/views/pedidos2/pedidos/reportes/DatosSRINotasCredito.vue');

export default {
    data() {
        return {
            popupImprimir: false,
            popupImprime: false,
            popupActa: false,
            datos: [],
            id: '',
            tdo: '',
            tip: '',
            factu: [],
            activePrompt: false,
            arrayPeriodo: [],
            busqueda: {
                cedula: '',
            },
            arrayCliente: [],
            arrayClientePrefacturas: [],
            ObjectClientSelected: {},
            mostrarBusquedaCliente: false,
            datacliente: {},
            popupFR: false,
            datosFR: [],
            empresa: '',
            idempresa: '',
            ven_desc_por1: null,
            ven_desc_por_unique: [],
            tip_ven_codigo_por_unique: [],
            clientesreporte: [],
            inputDescuento: 0,
            subtotal: 0,
            descuento: 0,
            subtotalDescuento: 0,
            iva: 0,
            transporte: 0,
            total: 0,
            descuentoVariacion: false,
            inputValid: false,
            inputValidtipo: false,
            clientesVariacionP: false,
            clientesVariacionC: false,
            clientesVariacion: false,
            datosAllFR: [],
            datosAllFROriginal: [],
            fechaActual: '',
            dataclienteunique: {
                id_usuario: '',
                nombreCliente: '',
                ruc_cliente: '',
                clientesidPerseo: '',
            },
            SelectCliente: '',
            datosProlipa: '',
            datosCalmed: '',
            codigo: '',
            checkBox2: false,
            checkBox666: false,
            options: [{
                    value: null,
                    label: 'Todos'
                },
                {
                    value: 'pendiente',
                    label: 'Solo Pendiente'
                },
                {
                    value: 'ordenar',
                    label: 'Ordenar Primero Pendientes'
                },
                {
                    value: 'marcadas',
                    label: 'Solo lo Seleccionado'
                }
            ],
            selectedOption: null,
            checkMarcarLLenar: false,
            isLoading: false,
            selectAll: false,
            popupPrefacturaANotas: false,
            tipoVentaVariacion: false,
            activePrompt: false,
            tipo_ven_codigo: 0,
            optionsVenta: [{
                    value: 0,
                    label: 'Seleccione tipo de venta.'
                },
                {
                    value: 1,
                    label: 'venta directa'
                },
                {
                    value: 2,
                    label: 'venta lista'
                },
            ],
            empresaVariacion: null,
            tipoVariacion: null,
            NotasIntercambio: [],
            DocumentoDetalleVenta: [],
            DocumentoVenta: [],
            popupDocumento: false,
            verNotasIntercambio: false,
            letra: '',
            validacionNovariacion: false,
            validacionSinVariacion: false,
            documentosVentas: [],
            codigosVentas: [],
            popupNotaDeCredito: false,
            selectedTab: 'saldos',
            NotasCredito: [],
            verNotasCredito: false,
            NotasCreditoClientes: [],
            verNotasCreditoClientes: false,
            configdateTimePicker: {
                enableTime: true,
                dateFormat: 'Y-m-d',
                onChange: this.onDateChange,
            },
            validacionNotasCredito: false,
            validacionCantNotasCredito: false,
            popupSRI: false,
            itemSeleccionado: {},
            //stock no disponible 
            popupVisible: false, // Controla la visibilidad del popup
            productosNoDisponibles: [] // Aquí almacenamos los productos sin stock suficiente
        };
    },
    components: {
        "v-select": vSelect,
        flatPickr,
        documentoVenta,
        DatosSRINotasCredito,
    },
    mounted() {
        this.calculateTotals();
        this.obtenerFechaActual();
    },
    props: {
        periodoSelect: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    computed: {
        checkedItemCount() {
            return this.datosAllFR.filter(item => item.check_real_facturar).length;
        }
    },
    created() {
        let me = this
        me.usuario = JSON.parse(localStorage.getItem("usuario"))
    },
    watch: {
        datosAllFR: {
            handler() {
                this.calculateTotals();
            },
            deep: true
        },
        // inputDescuento: 'calculateTotals',
        inputDescuento(newValue) {
            // Limitar el valor de inputDescuento entre 0 y 100
            if (newValue < 0) {
                this.inputDescuento = 0;
            } else if (newValue > 100) {
                this.inputDescuento = 100;
            }
            // Llama a la función de cálculo de totales
            this.calculateTotals();
        }
    },
    methods: {
        handleCloseAbono() {
            let me = this;
            me.popupPrefacturaANotas = true;
            me.$vs.notify({
                color: 'danger',
                title: 'Mensaje',
                text: 'No puede salir hasta que se complete la convercion del documento.',
            })
        },
        onDateChange(selectedDates, dateStr, instance) {
            instance.close();
        },
        acceptAlert() {
            let me = this;
            if (me.tipo_ven_codigo == 0) {
                me.activePrompt = true;
                me.$vs.notify({
                    color: 'danger',
                    title: 'Mensaje',
                    text: 'Debe seleccionar el tipo de venta.'
                })
                return
            } else {
                me.crearFacturaReal(me.empresaVariacion, me.tipoVariacion);
                me.tipoVentaVariacion = true;
            }
        },
        close() {
            this.$vs.notify({
                color: 'danger',
                title: 'Mensaje',
                text: 'Has cancelado el cambio saldos a notas!'
            })
        },
        toggleAll() {
            this.datosAllFR.forEach(tr => {
                if (!tr.check_cantidades) {
                    tr.check_real_facturar = this.selectAll;
                }
            });
        },
        ValidarNotas() {
            this.datosAllFR.forEach(tr => {
                if (!tr.check_real_facturar) {
                    tr.check_real_facturar = true;
                }
            });
        },
        applyFilters() {
            let filteredData = [...this.datosAllFROriginal];

            if (this.selectedOption === 'pendiente') {
                filteredData = filteredData.filter(item => !item.check_cantidades);
                if (filteredData.length == 0) {
                    this.$vs.notify({
                        title: 'Error',
                        text: 'No tiene cantidades Pendientes.',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                }
            } else if (this.selectedOption === 'ordenar') {
                filteredData.sort((a, b) => {
                    return (a.check_cantidades === b.check_cantidades) ? 0 : (a.check_cantidades ? 1 : -1);
                });
            } else if (this.selectedOption === 'marcadas') {
                filteredData = filteredData.filter(item => item.check_real_facturar);
                if (filteredData.length == 0) {
                    this.$vs.notify({
                        title: 'Error',
                        text: 'No tiene cantidades seleccionadas.',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                }
            }

            this.datosAllFR = filteredData;
        },
        cambioItems() {
            if (this.checkBox666) {
                this.datosAllFR = this.datosAllFR.filter(item => !item.check_cantidades);
            } else {
                this.datosAllFR = [...this.datosAllFROriginal];
            }
        },
        quitarvalidacion() {
            let me = this;

            // Calcular la cantidad real a facturar
            me.datosAllFR.forEach(item => {
                const cantidadRealFacturar = Math.max(0, (item.det_ven_cantidad - item.det_ven_dev) - (item.cantidad_facturada - item.cantidad_nota_credito));
                item.cantidad_real_facturar = cantidadRealFacturar;
                item.check_cantidades = cantidadRealFacturar === 0;
            });

            // Actualizar check_cantidades según el estado de checkBox2
            if (this.checkBox2) {
                me.datosAllFR.forEach(item => {
                    if (item.check_cantidades) {
                        item.check_cantidades = false;
                    }
                });
            } else {
                me.datosAllFR.forEach(item => {
                    item.check_cantidades = item.cantidad_real_facturar === 0;
                });
            }
        },
        validateInput(tr) {
            // Convertir a número
            const value = parseFloat(tr.cantidad_real_facturar);
            const max = Math.max(0, (tr.det_ven_cantidad - tr.det_ven_dev) - (tr.cantidad_facturada - tr.cantidad_nota_credito));
            if (!this.checkBox2) {
                // Asegúrate de que el valor sea un número
                if (isNaN(value) || value <= 0) {
                    tr.cantidad_real_facturar = 0; // Ajustar a 0 si es negativo o NaN
                    if (this.checkMarcarLLenar == true) {
                        tr.check_real_facturar = false;
                    }
                } else if (value > max) {
                    tr.cantidad_real_facturar = max; // Ajustar al máximo si se excede
                    this.$vs.notify({
                        title: 'Error',
                        text: 'No puede ingresar más, ya que no tiene suficiente cantidad disponible para facturar.',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                    return;
                } else {
                    // Aquí simplemente se asegura que `value` sea un número
                    tr.cantidad_real_facturar = value; // Guarda como número
                    if (this.checkMarcarLLenar == true) {
                        tr.check_real_facturar = true;
                    }
                }
            }

        },
        validateInputNota(tr) {
            // Convertir a número
            const value = parseFloat(tr.cantidad_real_facturar);
            const max = Math.abs((tr.det_ven_cantidad - tr.det_ven_dev) - (tr.cantidad_facturada - tr.cantidad_nota_credito));
            if (!this.checkBox2) {
                // Asegúrate de que el valor sea un número
                if (isNaN(value) || value <= 0) {
                    tr.cantidad_real_facturar = 0; // Ajustar a 0 si es negativo o NaN
                    if (this.checkMarcarLLenar == true) {
                        tr.check_real_facturar = false;
                    }
                } else if (value > max) {
                    tr.cantidad_real_facturar = max; // Ajustar al máximo si se excede
                    this.$vs.notify({
                        title: 'Error',
                        text: 'No puede ingresar más, ya que no tiene suficiente cantidad disponible para facturar.',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                    return;
                } else {
                    // Aquí simplemente se asegura que `value` sea un número
                    tr.cantidad_real_facturar = value; // Guarda como número
                    if (this.checkMarcarLLenar == true) {
                        tr.check_real_facturar = true;
                    }
                }
            }

        },
        getcod(a, callback, tipoVariacion) {
            let me = this;
            let letraEmpresa, url, codigoVenta;

            // Determinar la letra de la empresa
            if (a === 1) {
                letraEmpresa = 'P';
            } else if (a === 3) {
                letraEmpresa = 'C';
            } else {
                letraEmpresa = '';
            }

            // console.log('no variacion', me.validacionNovariacion);
            // console.log('sin variacion', me.validacionSinVariacion);
            // console.log('tipoVariacion', tipoVariacion);
            // console.log('me.tipoVariacion', me.tipoVariacion);

            // Determinar la URL según tipo de variación
            if (tipoVariacion == 1 && !me.validacionSinVariacion) {
                if (me.tipo_ven_codigo == 1) {
                    url = 'Get_CodVenta?letra=AI&id=' + a;
                } else if (me.tipo_ven_codigo == 2) {
                    url = 'Get_CodVenta?letra=BC&id=' + a;
                }
            } else if (!tipoVariacion && !me.validacionSinVariacion) {
                if (me.tipo_ven_codigo == 1) {
                    url = 'Get_CodVenta?letra=AI&id=' + a;
                } else if (me.tipo_ven_codigo == 2) {
                    url = 'Get_CodVenta?letra=BC&id=' + a;
                }
            }
            if (tipoVariacion == 1 && me.validacionSinVariacion) {
                if (me.tipo_ven_codigo == 1) {
                    url = 'Get_CodVenta?letra=AI&id=' + a;
                } else if (me.tipo_ven_codigo == 2) {
                    url = 'Get_CodVenta?letra=BC&id=' + a;
                }
            }

            // Realizar la solicitud HTTP
            this.$http.get(this.$server_url + url)
                .then(response => {
                    const datos = response.data;

                    // Verificar si hay datos suficientes
                    if (datos.length < 2) {
                        callback(null); // Devolver null si los datos no son suficientes
                        return;
                    }

                    const codigoBase = datos[0];
                    const numeroBase = datos[1]; // Asegurar que sea un número
                    const numeroSecuencial = parseInt(datos[1]); // Asegurar que sea un número

                    // Determinar el prefijo del tipo de venta
                    let prefijoVenta = '';
                    if (me.tipo_ven_codigo === 1) {
                        prefijoVenta = 'AI';
                    } else if (me.tipo_ven_codigo === 2) {
                        prefijoVenta = 'BC';
                    }

                    // Generar el código base con los componentes
                    let codigoBaseComponente = `${codigoBase}-${letraEmpresa}-${this.periodoSelect.codigo_contrato}-${this.usuario.iniciales}-${numeroBase}`;

                    // Generar el código de venta según tipo de variación
                    if (tipoVariacion === 1) {
                        // Si hay variación, se asigna el prefijo 'N-'
                        codigoVenta = `N-${letraEmpresa}-${this.periodoSelect.codigo_contrato}-${this.usuario.iniciales}-${prefijoVenta}${numeroSecuencial}`;
                    } else {
                        // Si no hay variación, se utiliza el código base sin el prefijo 'N-'
                        codigoVenta = codigoBaseComponente;
                    }

                    // Llamar al callback con el código de venta
                    callback(codigoVenta);
                })
                .catch(error => {
                    console.error("Error al obtener el código de venta:", error);
                    callback(null); // Manejar el error devolviendo null
                });
        },
        getcodFR(a, callback, tipoVariacion) {
            let me = this;
            let letraEmpresa, url, codigoVenta;

            // Determinar la letra de la empresa
            if (a === 1) {
                letraEmpresa = 'P';
            } else if (a === 3) {
                letraEmpresa = 'C';
            } else {
                letraEmpresa = '';
            }
            if (tipoVariacion === 1 || tipoVariacion === 2) {
                return;
            }

            if (!me.tipoVariacion && me.validacionNovariacion && !me.validacionSinVariacion) {
                console.log("validacionNovariacion  001")
                url = 'Get_CodVenta?letra=FR&id=' + a;
            }
            if (!me.tipoVariacion && !me.validacionNovariacion && me.validacionSinVariacion) {
                console.log("validacionSinVariacion  002")
                url = 'Get_CodVenta?letra=FR&id=' + a;
            }

            if (tipoVariacion && me.validacionNovariacion && !me.validacionSinVariacion) {
                console.log("tipoVariacion  003")
                url = 'Get_CodVenta?letra=FR&id=' + a;
            }
            if (tipoVariacion && !me.validacionNovariacion && me.validacionSinVariacion) {
                console.log("validacionSinVariacion  004")
                url = 'Get_CodVenta?letra=FR&id=' + a;
            }

            // Realizar la solicitud HTTP
            this.$http.get(this.$server_url + url)
                .then(response => {
                    const datos = response.data;

                    // Verificar si hay datos suficientes
                    if (datos.length < 2) {
                        callback(null); // Devolver null si los datos no son suficientes
                        return;
                    }

                    const codigoBase = datos[0];
                    const numeroBase = datos[1]; // Asegurar que sea un número
                    const numeroSecuencial = parseInt(datos[1]); // Asegurar que sea un número

                    // Generar el código base con los componentes
                    let codigoBaseComponente = `${codigoBase}-${letraEmpresa}-${this.periodoSelect.codigo_contrato}-${this.usuario.iniciales}-${numeroBase}`;

                    codigoVenta = codigoBaseComponente;

                    // Llamar al callback con el código de venta
                    callback(codigoVenta);
                })
                .catch(error => {
                    console.error("Error al obtener el código de venta:", error);
                    callback(null); // Manejar el error devolviendo null
                });
        },
        getcodNC(a, callback, tipoVariacion) {
            let me = this;
            let letraEmpresa, url, codigoVenta;

            // Determinar la letra de la empresa
            if (a === 1) {
                letraEmpresa = 'P';
            } else if (a === 3) {
                letraEmpresa = 'C';
            } else {
                letraEmpresa = '';
            }

            if (!me.tipoVariacion && me.validacionNovariacion && !me.validacionSinVariacion) {
                console.log("validacionNovariacion  001")
                url = 'Get_CodVenta?letra=NC&id=' + a;
            }
            if (!me.tipoVariacion && !me.validacionNovariacion && me.validacionSinVariacion) {
                console.log("validacionSinVariacion  002")
                url = 'Get_CodVenta?letra=NC&id=' + a;
            }

            if (tipoVariacion && me.validacionNovariacion && !me.validacionSinVariacion) {
                console.log("tipoVariacion  003")
                url = 'Get_CodVenta?letra=NC&id=' + a;
            }
            if (tipoVariacion && !me.validacionNovariacion && me.validacionSinVariacion) {
                console.log("validacionSinVariacion  004")
                url = 'Get_CodVenta?letra=NC&id=' + a;
            }

            // Realizar la solicitud HTTP
            this.$http.get(this.$server_url + url)
                .then(response => {
                    const datos = response.data;

                    // Verificar si hay datos suficientes
                    if (datos.length < 2) {
                        callback(null); // Devolver null si los datos no son suficientes
                        return;
                    }

                    const codigoBase = datos[0];
                    const numeroBase = datos[1]; // Asegurar que sea un número
                    const numeroSecuencial = parseInt(datos[1]); // Asegurar que sea un número

                    // Determinar el prefijo del tipo de venta
                    let prefijoVenta = '';
                    if (me.tipo_ven_codigo === 1) {
                        prefijoVenta = 'AI';
                    } else if (me.tipo_ven_codigo === 2) {
                        prefijoVenta = 'BC';
                    }

                    // Generar el código base con los componentes
                    let codigoBaseComponente = `${codigoBase}-${letraEmpresa}-${this.periodoSelect.codigo_contrato}-${this.usuario.iniciales}-${numeroBase}`;

                    // Generar el código de venta según tipo de variación
                    codigoVenta = codigoBaseComponente;

                    // Llamar al callback con el código de venta
                    callback(codigoVenta);
                })
                .catch(error => {
                    console.error("Error al obtener el código de venta:", error);
                    callback(null); // Manejar el error devolviendo null
                });
        },
        guardarDatos() {
            let me = this;
            this.isLoading = true;
            // Validaciones
            if (!this.ObjectClientSelected.nombreInstitucion) {
                this.isLoading = false;
                this.$vs.notify({
                    title: 'Error',
                    text: 'La institución es requerida.',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                });
                return;
            }

            if (!this.dataclienteunique || !this.dataclienteunique.nombreCliente) {
                this.isLoading = false;
                this.$vs.notify({
                    title: 'Error',
                    text: 'El cliente es requerido.',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                });
                return;
            }

            const itemsSeleccionados = this.datosAllFR.filter(item => item.check_real_facturar);

            if (itemsSeleccionados.length === 0) {
                this.isLoading = false;
                this.$vs.notify({
                    title: 'Error',
                    text: 'Debe seleccionar al menos un ítem.',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                });
                return;
            }

            // Verificar si hay cantidades en 0
            const itemsConCantidadCero = itemsSeleccionados.filter(item => item.cantidad_real_facturar == 0);
            if (itemsConCantidadCero.length > 0) {
                this.isLoading = false;
                this.$vs.notify({
                    title: 'Advertencia',
                    text: 'Hay ítems seleccionados con cantidad en 0.',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                return;
            }

            if (me.descuentoVariacion && !me.inputDescuento) {
                this.isLoading = false;
                this.$vs.notify({
                    title: 'Error',
                    text: 'Debes ingresar el descuento.',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                });
                return;
            }

            const datosParaGuardar = {
                institucion: this.ObjectClientSelected.idInstitucion,
                cliente: this.dataclienteunique,
                items: itemsSeleccionados,
                subtotal: this.subtotal.toFixed(2),
                descuento_porcentaje: this.inputDescuento ? this.inputDescuento : this.ven_desc_por_unique[0],
                descuento: this.descuento.toFixed(2),
                subtotalDescuento: this.subtotalDescuento.toFixed(2),
                iva: this.iva.toFixed(2),
                transporte: this.transporte.toFixed(2),
                total: this.total.toFixed(2),
            };

            let formData = new FormData();
            formData.append("data_detalle", JSON.stringify(datosParaGuardar.items));
            formData.append("ven_codigo", me.codigo);
            formData.append("id_empresa", me.idempresa);
            formData.append("ven_desc_por", datosParaGuardar.descuento_porcentaje);
            formData.append("ven_iva_por", 0);
            formData.append("ven_descuento", datosParaGuardar.descuento);
            formData.append("ven_iva", datosParaGuardar.iva);
            formData.append("ven_transporte", datosParaGuardar.transporte);
            formData.append("ven_valor", datosParaGuardar.total);
            formData.append("ven_subtotal", datosParaGuardar.subtotal);
            formData.append("id_ins_depacho", datosParaGuardar.institucion);
            formData.append("periodo_id", me.periodoSelect.idperiodoescolar);
            formData.append("ven_cliente", datosParaGuardar.cliente.id_usuario);
            formData.append("clientesidPerseo", datosParaGuardar.cliente.clientesidPerseo);
            formData.append("ven_fecha", me.fechaActual);
            formData.append("user_created", me.usuario.idusuario);
            // formData.append("data_ventas", JSON.stringify(me.perseo));

            // console.log('Datos a guardar:', datosParaGuardar);
            for (let [key, value] of formData.entries()) {
                console.log(`${key}:`, value);
            }
            // Aquí puedes realizar una llamada a tu API para guardar los datos
            this.$http.post(this.$server_url + "PostFacturarReal", formData)
                .then(response => {
                    // Manejar la respuesta de éxito
                    this.$vs.notify({
                        title: 'Éxito',
                        text: 'Datos guardados correctamente.',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    });
                    this.popupFR = false; // Cierra el popup
                })
                .catch(error => {
                    // Manejar el error
                    this.$vs.notify({
                        title: 'Error',
                        text: 'Error al guardar los datos.',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                    console.error('Error al guardar datos:', error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        validarSeleccionCliente() {
            let me = this;
            if (!this.SelectCliente) {
                me.$vs.notify({
                    title: 'Sin datos',
                    text: 'No se selecciono Cliente.',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                });
            } else {
                me.dataclienteunique.id_usuario = me.SelectCliente.ven_cliente;
                me.dataclienteunique.nombreCliente = me.SelectCliente.clienteUsuario;
                me.dataclienteunique.ruc_cliente = me.SelectCliente.ruc_cliente;
                me.dataclienteunique.clientesidPerseo = me.SelectCliente.clientesidPerseo;
            }
        },
        obtenerFechaActual() {
            const fecha = new Date();
            const anio = fecha.getFullYear();
            const mes = String(fecha.getMonth() + 1).padStart(2, '0');
            const dia = String(fecha.getDate()).padStart(2, '0');
            this.fechaActual = `${anio}-${mes}-${dia}`;
        },
        calculateTotals() {
            // Inicializa subtotal y otros valores
            this.subtotal = 0;
            this.descuento = 0;
            this.subtotalDescuento = 0;
            this.total = 0;

            // Calcula subtotal solo para los items seleccionados
            const subtotalItems = this.datosAllFR.reduce((sum, tr) => {
                if (tr.check_real_facturar) { // Solo suma si el checkbox está marcado
                    return sum + ((tr.det_ven_valor_u || 0) * (tr.cantidad_real_facturar || 0));
                }
                return sum;
            }, 0);

            this.subtotal = subtotalItems;

            // Calcula descuento
            if (this.descuentoVariacion) {
                this.descuento = (this.inputDescuento > 0 ? (subtotalItems * this.inputDescuento / 100) : 0);
            } else {
                this.descuento = (subtotalItems * (this.ven_desc_por_unique[0] || 0) / 100);
            }

            // Calcula subtotal después del descuento
            this.subtotalDescuento = this.subtotal - this.descuento;
            // let ivaporcentaje = me.arrayClientePrefacturas.filter(f => f.ven_iva_por != null)
            this.iva = 0; // IVA es siempre 0
            this.transporte = 0; // Transporte es siempre 0
            this.total = this.subtotalDescuento; // Total es igual a subtotalDescuento
        },
        confirmarVariaciontipo(empresa, tipo) {
            let me = this;
            me.empresaVariacion = null;
            me.tipoVariacion = null;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Confirmación',
                text: '¿Está seguro de variar el tipo de venta?',
                accept: function () {
                    me.tipo_ven_codigo = 0;
                    me.empresaVariacion = empresa;
                    me.tipoVariacion = tipo;
                    me.activePrompt = true;
                    // me.crearFacturaReal(empresa,tipo);
                    // me.tipoVentaVariacion = true;
                },
                reject: function () {
                    console.log('Confirmación rechazada');
                }
            });
        },

        confirmarVariaciontipoDescuento(empresa, tipo) {
            let me = this;
            me.empresaVariacion = null;
            me.tipoVariacion = null;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Confirmación',
                text: '¿Está seguro de variar el descuento y el tipo de venta?',
                accept: function () {
                    // me.crearFacturaReal(empresa,tipo);
                    me.tipo_ven_codigo = 0;
                    me.empresaVariacion = empresa;
                    me.tipoVariacion = tipo;
                    me.descuentoVariacion = true;
                    me.tipoVentaVariacion = true;
                    me.activePrompt = true;

                },
                reject: function () {
                    console.log('Confirmación rechazada');
                }
            });
        },
        confirmacionVariacion(empresa, tipo) {
            let me = this;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Confirmación',
                text: '¿Está seguro de variar el descuento en el reporte?',
                accept: function () {
                    me.crearFacturaReal(empresa, tipo);
                    me.descuentoVariacion = true;
                },
                reject: function () {
                    console.log('Confirmación rechazada');
                }
            });
        },
        crearFacturaReal(empresa, tipo) {
            console.log("empresa", empresa, "tipo", tipo);
            let me = this;
            me.datosFR = [];
            me.idempresa = '';
            me.empresa = '';
            me.codigo = '';
            me.clientesreporte = [];
            const clientesSet = new Map(); // Usar un Map para clientes únicos

            this.obtenerFechaActual();

            if (empresa == 1) {
                me.datosFR = me.arrayClientePrefacturas.filter(f => f.id_empresa == empresa);
                me.idempresa = me.datosFR[0].id_empresa;
                me.empresa = me.datosFR[0].descripcion_corta;

                me.datosProlipa.forEach(prefactura => {
                    // Extraer clientes únicos
                    if (prefactura.ven_cliente !== undefined && prefactura.ruc_cliente !== undefined && prefactura.clienteUsuario !== undefined && prefactura.clientesidPerseo !== undefined) {
                        const clienteInfo = {
                            ven_cliente: prefactura.ven_cliente,
                            ruc_cliente: prefactura.ruc_cliente,
                            clienteUsuario: prefactura.clienteUsuario,
                            clientesidPerseo: prefactura.clientesidPerseo,
                        };
                        // Agregar como clave en el Map para mantener la unicidad
                        clientesSet.set(clienteInfo.ruc_cliente, clienteInfo);
                    }
                });

                // Convertir el Map a un array
                me.clientesreporte = Array.from(clientesSet.values());

                // Manejo de cliente único
                if (me.clientesreporte.length === 1) {
                    me.dataclienteunique = {
                        id_usuario: me.clientesreporte[0].ven_cliente,
                        nombreCliente: me.clientesreporte[0].clienteUsuario,
                        ruc_cliente: me.clientesreporte[0].ruc_cliente,
                        clientesidPerseo: me.clientesreporte[0].clientesidPerseo,
                    };
                }

                me.clientesVariacionP = clientesSet.size > 1;
                me.clientesVariacion = me.clientesVariacionP;
                if (tipo === 1) {
                    me.getcod(empresa, (codigoVenta) => {
                        if (codigoVenta) {
                            me.codigo = codigoVenta;
                            console.log("Código de venta asignado:", me.codigo);
                        } else {
                            console.log("No se pudo obtener el código de venta.");
                            this.$vs.notify({
                                title: 'Error',
                                text: 'No se pudo obtener el código de venta.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                            return;
                        }
                    }, tipo);
                }
                if (tipo === 2) {
                    me.getcodNC(empresa, (codigoVenta) => {
                        if (codigoVenta) {
                            me.codigo = codigoVenta;
                            console.log("Código de venta asignado:", me.codigo);
                        } else {
                            console.log("No se pudo obtener el código de venta.");
                            this.$vs.notify({
                                title: 'Error',
                                text: 'No se pudo obtener el código de venta.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                            return;
                        }
                    }, tipo);
                } else {
                    me.getcodFR(empresa, (codigoVenta) => {
                        if (codigoVenta) {
                            me.codigo = codigoVenta;
                            console.log("Código de venta asignado:", me.codigo);
                        } else {
                            console.log("No se pudo obtener el código de venta.");
                            this.$vs.notify({
                                title: 'Error',
                                text: 'No se pudo obtener el código de venta.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                            return;
                        }
                    }, tipo);
                }

            } else if (empresa == 3) {
                me.datosFR = me.arrayClientePrefacturas.filter(f => f.id_empresa == empresa);
                me.idempresa = me.datosFR[0].id_empresa;
                me.empresa = me.datosFR[0].descripcion_corta;

                me.datosCalmed.forEach(prefactura => {
                    // Extraer clientes únicos
                    if (prefactura.ven_cliente !== undefined && prefactura.ruc_cliente !== undefined && prefactura.clienteUsuario !== undefined && prefactura.clientesidPerseo !== undefined) {
                        const clienteInfo = {
                            ven_cliente: prefactura.ven_cliente,
                            ruc_cliente: prefactura.ruc_cliente,
                            clienteUsuario: prefactura.clienteUsuario,
                            clientesidPerseo: prefactura.clientesidPerseo,
                        };
                        // Agregar como clave en el Map para mantener la unicidad
                        clientesSet.set(clienteInfo.ruc_cliente, clienteInfo);
                    }
                });

                // Convertir el Map a un array
                me.clientesreporte = Array.from(clientesSet.values());

                // Manejo de cliente único
                if (me.clientesreporte.length === 1) {
                    me.dataclienteunique = {
                        id_usuario: me.clientesreporte[0].ven_cliente,
                        nombreCliente: me.clientesreporte[0].clienteUsuario,
                        ruc_cliente: me.clientesreporte[0].ruc_cliente,
                        clientesidPerseo: me.clientesreporte[0].clientesidPerseo,
                    };
                }

                me.clientesVariacionC = clientesSet.size > 1;
                me.clientesVariacion = me.clientesVariacionC;

                if (tipo === 1) {
                    me.getcod(empresa, (codigoVenta) => {
                        if (codigoVenta) {
                            me.codigo = codigoVenta;
                            console.log("Código de venta asignado:", me.codigo);
                        } else {
                            console.log("No se pudo obtener el código de venta.");
                            this.$vs.notify({
                                title: 'Error',
                                text: 'No se pudo obtener el código de venta.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                            return;
                        }
                    }, tipo);
                }
                if (tipo === 2) {
                    me.getcodNC(empresa, (codigoVenta) => {
                        if (codigoVenta) {
                            me.codigo = codigoVenta;
                            console.log("Código de venta asignado:", me.codigo);
                        } else {
                            console.log("No se pudo obtener el código de venta.");
                            this.$vs.notify({
                                title: 'Error',
                                text: 'No se pudo obtener el código de venta.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                            return;
                        }
                    }, tipo);
                } else {
                    me.getcodFR(empresa, (codigoVenta) => {
                        if (codigoVenta) {
                            me.codigo = codigoVenta;
                            console.log("Código de venta asignado:", me.codigo);
                        } else {
                            console.log("No se pudo obtener el código de venta.");
                            this.$vs.notify({
                                title: 'Error',
                                text: 'No se pudo obtener el código de venta.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                            return;
                        }
                    }, tipo);
                }
            }

            me.datosAllFR = [];
            me.$vs.loading();
            if (tipo === 1) {
                me.agruparCods(me.idempresa, tipo);
            } else if (tipo === 2) {
                me.agruparCodsNC(me.idempresa, tipo);
            } else {
                me.agrupar(me.idempresa, tipo);
            }
        },
        getCantidadFacturada() {
            let me = this;

            return this.$http.get(this.$server_url + 'getCantidadFacturada', {
                params: {
                    institucion: me.ObjectClientSelected.idInstitucion,
                    empresa: me.idempresa,
                    periodo: me.periodoSelect.idperiodoescolar
                }
            }).then(res => {
                return res.data; // Retorna los datos de la respuesta
            }).catch(err => {
                console.log(err);
                return []; // Retorna un array vacío en caso de error
            });
        },
        getCantidadNotaCredito() {
            let me = this;

            return this.$http.get(this.$server_url + 'getCantidadNotaCredito', {
                params: {
                    institucion: me.ObjectClientSelected.idInstitucion,
                    empresa: me.idempresa,
                    periodo: me.periodoSelect.idperiodoescolar
                }
            }).then(res => {
                return res.data; // Retorna los datos de la respuesta
            }).catch(err => {
                console.log(err);
                return []; // Retorna un array vacío en caso de error
            });
        },
        agruparCods(empresa, tipo) {
            let me = this;
            let promises = [];
            me.datosAllFROriginal = [];
            me.codigosVentas = [];

            // Obtener las prefacturas
            me.datosFR.forEach(fr => {
                if (fr.ven_codigo) {
                    let promise = this.$http.get(this.$server_url + 'Get_PREFacturaCodigos?ven_codigo=' + fr.ven_codigo + '&idemp=' + fr.id_empresa)
                        .then(res => {
                            return res.data; // Retorna directamente los datos
                        })
                        .catch(err => {
                            console.log(err);
                            return []; // Retorna un array vacío en caso de error
                        });
                    promises.push(promise);
                }
            });

            // Espera a que todas las promesas se resuelvan
            Promise.all(promises)
                .then(results => {
                    me.codigosVentas = results.flat(); // Aplana el array
                })
                .catch(err => {
                    me.$vs.loading.close(); // Cierra el loading
                    console.log(err);
                })
                .finally(() => {
                    me.agruparN(empresa, tipo);
                });
        },
        agruparCodsNC(empresa, tipo) {
            let me = this;
            let promises = [];
            me.datosAllFROriginal = [];
            me.documentosVentas = [];

            // Obtener las prefacturas
            me.datosFR.forEach(fr => {
                if (fr.ven_codigo) {
                    me.documentosVentas.push({
                        ven_codigo: fr.ven_codigo,
                        idemp: fr.id_empresa
                    });
                    let promise = this.$http.get(this.$server_url + 'Get_PREFactura?ven_codigo=' + fr.ven_codigo + '&idemp=' + fr.id_empresa)
                        .then(res => {
                            return res.data; // Retorna directamente los datos
                        })
                        .catch(err => {
                            console.log(err);
                            return []; // Retorna un array vacío en caso de error
                        });
                    promises.push(promise);
                }
            });

            // Espera a que todas las promesas se resuelvan
            Promise.all(promises)
                .then(results => {
                    me.datosAllFR = results.flat(); // Aplana el array

                    // Agrupación por pro_codigo
                    const grouped = me.datosAllFR.reduce((acc, item) => {
                        const existing = acc.find(el => el.pro_codigo === item.pro_codigo);
                        if (existing) {
                            // Sumar valores de las propiedades correspondientes
                            existing.det_ven_dev += item.det_ven_dev;
                            existing.det_ven_cantidad += item.det_ven_cantidad;
                        } else {
                            acc.push({
                                ...item
                            });
                        }
                        return acc;
                    }, []);

                    // Obtener cantidades facturadas y cantidades de nota crédito
                    return Promise.all([
                        me.getCantidadFacturada(empresa),
                        me.getCantidadNotaCredito(empresa) // Llamar la nueva función para obtener cantidad de nota crédito
                    ]).then(([cantidadFacturada, cantidadNotaCredito]) => {
                        // Crear un mapa para las cantidades facturadas
                        const cantidadFacturadaMap = new Map(cantidadFacturada.map(item => [item.pro_codigo, item.det_ven_cantidad]));
                        const cantidadNotaCreditoMap = new Map(cantidadNotaCredito.map(item => [item.pro_codigo, item.det_ven_cantidad]));

                        // Filtrar y calcular la cantidad real a facturar
                        me.datosAllFR = grouped
                            .map(item => {
                                // Calcula la cantidad real a facturar
                                const cantidadRealFacturar = (item.det_ven_cantidad - item.det_ven_dev);
                                const cantidadFacturada = cantidadFacturadaMap.get(item.pro_codigo) || 0;
                                const cantidadNotaCredito = cantidadNotaCreditoMap.get(item.pro_codigo) || 0; // Obtener la cantidad de nota crédito

                                // Solo continuar si la cantidad facturada es mayor que la diferencia entre cantidad y devoluciones
                                if (cantidadRealFacturar < cantidadFacturada) {
                                    const cantidadRealFacturarResult = cantidadFacturada - cantidadRealFacturar;

                                    // Si cantidad_real_facturar es igual a cantidad_nota_credito, no incluir el item
                                    if (cantidadRealFacturarResult === cantidadNotaCredito) {
                                        return null; // Excluir este item
                                    }

                                    return {
                                        ...item,
                                        cantidad_real_facturar: cantidadRealFacturarResult - cantidadNotaCredito,
                                        cantidad_facturada: cantidadFacturada, // Añadir cantidad facturada
                                        cantidad_nota_credito: cantidadNotaCredito, // Añadir cantidad de nota crédito
                                        check_real_facturar: tipo == 2 && cantidadRealFacturar < cantidadFacturada && cantidadRealFacturarResult != cantidadNotaCredito ? true : false,
                                        check_cantidades: cantidadRealFacturar === 0, // Aquí utilizamos la variable ya calculada
                                    };
                                } else {
                                    // Si no cumple la condición, simplemente no incluir el item
                                    return null;
                                }
                            })
                            .filter(item => item !== null); // Filtra los nulls (excluye los items donde cantidad_real_facturar == cantidad_nota_credito)

                        // Actualiza la copia original para el filtrado
                        me.datosAllFROriginal = [...me.datosAllFR]; // Asegúrate de guardar la copia aquí
                        me.datosAllFR = me.datosAllFR.filter(item => item.cantidad_real_facturar > 0); // Filtra los items donde cantidad_real_facturar == 0
                        if (me.datosAllFR.length > 0) {
                            me.popupNotaDeCredito = me.datosAllFR.length > 0; // Establece el valor de popupFR
                        } else {
                            me.$vs.notify({
                                title: 'Sin datos',
                                text: 'No se encontraron desfases.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                    });
                })
                .catch(err => {
                    me.$vs.loading.close(); // Cierra el loading
                    console.log(err);
                })
                .finally(() => {
                    me.$vs.loading.close(); // Cierra el loading
                });
        },
        agruparN(empresa, tipo) {
            let me = this;
            let promises = [];
            me.datosAllFROriginal = [];
            me.documentosVentas = [];

            // Obtener las prefacturas
            me.datosFR.forEach(fr => {
                if (fr.ven_codigo) {
                    me.documentosVentas.push({
                        ven_codigo: fr.ven_codigo,
                        idemp: fr.id_empresa
                    });
                    let promise = this.$http.get(this.$server_url + 'Get_PREFactura?ven_codigo=' + fr.ven_codigo + '&idemp=' + fr.id_empresa)
                        .then(res => {
                            return res.data; // Retorna directamente los datos
                        })
                        .catch(err => {
                            console.log(err);
                            return []; // Retorna un array vacío en caso de error
                        });
                    promises.push(promise);
                }
            });

            // Espera a que todas las promesas de las prefacturas se resuelvan
            Promise.all(promises)
                .then(results => {
                    me.datosAllFR = results.flat(); // Aplana el array

                    // Agrupación por pro_codigo
                    const grouped = me.datosAllFR.reduce((acc, item) => {
                        const existing = acc.find(el => el.pro_codigo === item.pro_codigo);
                        if (existing) {
                            // Sumar valores de las propiedades correspondientes
                            existing.det_ven_dev += item.det_ven_dev;
                            existing.det_ven_cantidad += item.det_ven_cantidad;
                        } else {
                            acc.push({
                                ...item
                            });
                        }
                        return acc;
                    }, []);

                    // Obtener las cantidades facturadas y las cantidades de nota de crédito en paralelo
                    return Promise.all([
                        me.getCantidadFacturada(empresa),
                        me.getCantidadNotaCredito(empresa) // Se incluye la llamada a getCantidadNotaCredito
                    ]).then(([cantidadFacturada, cantidadNotaCredito]) => {
                        // Crear un mapa para las cantidades facturadas
                        const cantidadMap = new Map(cantidadFacturada.map(item => [item.pro_codigo, item.det_ven_cantidad]));
                        const notaCreditoMap = new Map(cantidadNotaCredito.map(item => [item.pro_codigo, item.det_ven_cantidad]));

                        me.datosAllFR = grouped.map(item => {
                            // Calcula la cantidad real a facturar
                            const cantidadRealFacturar = Math.max(0, (item.det_ven_cantidad - item.det_ven_dev) - ((cantidadMap.get(item.pro_codigo) || 0) - (notaCreditoMap.get(item.pro_codigo) || 0)));

                            return {
                                ...item,
                                cantidad_real_facturar: cantidadRealFacturar,
                                cantidad_facturada: cantidadMap.get(item.pro_codigo) || 0, // Añadir cantidad facturada
                                cantidad_nota_credito: notaCreditoMap.get(item.pro_codigo) || 0, // Añadir cantidad de nota de crédito
                                check_real_facturar: tipo === 1 && cantidadRealFacturar > 0 ? true : false,
                                check_cantidades: cantidadRealFacturar === 0, // Aquí utilizamos la variable ya calculada
                            };
                        });

                        // Actualiza la copia original para el filtrado
                        me.datosAllFROriginal = [...me.datosAllFR]; // Asegúrate de guardar la copia aquí
                        me.datosAllFR = me.datosAllFR.filter(item => item.cantidad_real_facturar > 0); // Filtra los items donde cantidad_real_facturar == 0
                        if (me.datosAllFR.length > 0) {
                            me.verificacionStock(me.datosAllFR, empresa);
                            // me.popupPrefacturaANotas = me.datosAllFR.length > 0; // Establece el valor de popupFR
                        } else {
                            me.$vs.notify({
                                title: 'Sin datos',
                                text: 'No se encontraron saldos.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                    });
                })
                .catch(err => {
                    me.$vs.loading.close(); // Cierra el loading
                    console.log(err);
                })
                .finally(() => {
                    me.$vs.loading.close(); // Cierra el loading
                });
        },
        verificacionStock(datos, empresa) {
            let me = this;
            let datosStock = [];

            // Preparamos los datos para enviarlos al backend
            datos.forEach(element => {
                let cal = new Object();
                cal.codigo = element.pro_codigo;
                cal.cantidad = element.cantidad_real_facturar;
                cal.empresa = empresa; // Pasamos la empresa también
                datosStock.push(cal);
            });

            // Enviamos los datos al servidor para verificar el stock
            this.$http.post(this.$server_url + 'verificarStock', datosStock)
                .then(res => {
                    if (res.data.status === 0) {
                        // Si no hay suficiente stock, mostramos la lista de productos sin stock
                        this.productosNoDisponibles = res.data.productos_no_disponibles;
                        this.popupVisible = true; // Abre el popup
                        return;

                        // // Notificamos sobre los productos que no tienen stock suficiente
                        // let mensaje = 'No hay suficiente stock para los siguientes productos: \n';
                        // productosNoDisponibles.forEach(producto => {
                        //     mensaje += `Código: ${producto.codigo}, Cantidad solicitada: ${producto.cantidad_solicitada}, Stock disponible: ${producto.stock_disponible}\n`;
                        // });

                        // me.$vs.notify({
                        //     text: mensaje, // Mensaje con los productos sin stock suficiente
                        //     color: 'warning',
                        //     iconPack: 'feather',
                        //     icon: 'icon-alert-triangle'
                        // });
                        // return; // Salimos del método si no hay stock suficiente
                    } else {
                        // Si el stock es suficiente, mostramos un mensaje de éxito
                        me.$vs.notify({
                            text: res.data.message, // Mensaje de éxito
                            color: 'success',
                            iconPack: 'feather',
                            icon: 'icon-check-circle'
                        });

                        // Si todo fue correcto, actualizamos los datos
                        me.popupPrefacturaANotas = me.datosAllFR.length > 0; // Establecemos el valor de popupFR
                    }

                })
                .catch(err => {
                    // Manejo de errores
                    console.error("Error al verificar el stock:", err);
                    me.$vs.notify({
                        text: 'Hubo un error al verificar el stock. Intenta nuevamente.',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                });
        },
        agrupar(empresa, tipo) {
            let me = this;
            let promises = [];
            me.datosAllFROriginal = [];
            me.documentosVentas = [];

            // Obtener las prefacturas
            me.datosFR.forEach(fr => {
                if (fr.ven_codigo) {
                    me.documentosVentas.push({
                        ven_codigo: fr.ven_codigo,
                        idemp: fr.id_empresa
                    });
                    let promise = this.$http.get(this.$server_url + 'Get_PREFactura?ven_codigo=' + fr.ven_codigo + '&idemp=' + fr.id_empresa)
                        .then(res => {
                            return res.data; // Retorna directamente los datos
                        })
                        .catch(err => {
                            console.log(err);
                            return []; // Retorna un array vacío en caso de error
                        });
                    promises.push(promise);
                }
            });

            // Espera a que todas las promesas de las prefacturas se resuelvan
            Promise.all(promises)
                .then(results => {
                    me.datosAllFR = results.flat(); // Aplana el array

                    // Agrupación por pro_codigo
                    const grouped = me.datosAllFR.reduce((acc, item) => {
                        const existing = acc.find(el => el.pro_codigo === item.pro_codigo);
                        if (existing) {
                            // Sumar valores de las propiedades correspondientes
                            existing.det_ven_dev += item.det_ven_dev;
                            existing.det_ven_cantidad += item.det_ven_cantidad;
                        } else {
                            acc.push({
                                ...item
                            });
                        }
                        return acc;
                    }, []);

                    // Obtener las cantidades facturadas y las cantidades de nota de crédito en paralelo
                    return Promise.all([
                        me.getCantidadFacturada(empresa),
                        me.getCantidadNotaCredito(empresa) // Se incluye la llamada a getCantidadNotaCredito
                    ]).then(([cantidadFacturada, cantidadNotaCredito]) => {
                        // Crear un mapa para las cantidades facturadas
                        const cantidadMap = new Map(cantidadFacturada.map(item => [item.pro_codigo, item.det_ven_cantidad]));
                        const notaCreditoMap = new Map(cantidadNotaCredito.map(item => [item.pro_codigo, item.det_ven_cantidad]));

                        me.datosAllFR = grouped.map(item => {
                            // Calcula la cantidad real a facturar
                            const cantidadRealFacturar = Math.max(0, item.det_ven_cantidad - item.det_ven_dev - ((cantidadMap.get(item.pro_codigo) || 0) - (notaCreditoMap.get(item.pro_codigo) || 0)));

                            return {
                                ...item,
                                cantidad_real_facturar: cantidadRealFacturar,
                                cantidad_facturada: cantidadMap.get(item.pro_codigo) || 0, // Añadir cantidad facturada
                                cantidad_nota_credito: notaCreditoMap.get(item.pro_codigo) || 0, // Añadir cantidad de nota de crédito
                                check_real_facturar: tipo === 1 && cantidadRealFacturar > 0 ? true : false,
                                check_cantidades: cantidadRealFacturar === 0, // Aquí utilizamos la variable ya calculada
                            };
                        });

                        // Actualiza la copia original para el filtrado
                        me.datosAllFROriginal = [...me.datosAllFR]; // Asegúrate de guardar la copia aquí

                        me.popupFR = me.datosAllFR.length > 0; // Establece el valor de popupFR
                    });
                })
                .catch(err => {
                    me.$vs.loading.close(); // Cierra el loading
                    console.log(err);
                })
                .finally(() => {
                    me.$vs.loading.close(); // Cierra el loading
                });
        },

        getAllPrefacturas(datos) {
            let me = this;
            me.ven_desc_por_unique = [];
            me.tip_ven_codigo_por_unique = [];
            me.datacliente = datos;
            me.tipo_ven_codigo = 0;
            me.tipoVariacion = null;
            me.validacionSinVariacion = false;
            me.validacionNovariacion = false;
            me.$vs.loading();

            this.$http.get(this.$server_url + 'getAllPrefacturas?busqueda=' + datos.idInstitucion + '&periodo=' + me.periodoSelect.idperiodoescolar)
                .then(function (res) {
                    me.arrayClientePrefacturas = res.data;
                    if (me.arrayClientePrefacturas.length === 0) {
                        me.$vs.notify({
                            title: 'Sin datos',
                            text: 'No se encontraron prefacturas.',
                            color: 'warning',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    } else {
                        // Extraer valores únicos de ven_desc_por y tip_ven_codigo
                        const descuentos = new Set();
                        const tiposVenta = new Set();

                        me.arrayClientePrefacturas.forEach(prefactura => {
                            if (prefactura.ven_desc_por !== undefined) {
                                descuentos.add(prefactura.ven_desc_por);
                            }
                        });

                        me.arrayClientePrefacturas.forEach(prefactura => {
                            if (prefactura.tip_ven_codigo !== undefined) {
                                tiposVenta.add(prefactura.tip_ven_codigo);
                            }
                        });

                        me.datosProlipa = me.arrayClientePrefacturas.filter(f => f.id_empresa == 1);
                        me.datosCalmed = me.arrayClientePrefacturas.filter(f => f.id_empresa == 3);

                        me.ven_desc_por_unique = Array.from(descuentos);
                        me.tip_ven_codigo_por_unique = Array.from(tiposVenta);
                        console.log('tipo venta all facturas', me.tip_ven_codigo_por_unique);

                        // Verificar si 'tip_ven_codigo_por_unique' tiene exactamente un elemento
                        if (me.tip_ven_codigo_por_unique.length === 1) {
                            me.validacionSinVariacion = true;
                            me.validacionNovariacion = false;
                            me.tipo_ven_codigo = me.tip_ven_codigo_por_unique[0]; // Asignamos el único valor
                        } else {
                            me.validacionNovariacion = true;
                            me.validacionSinVariacion = false;
                            me.tipo_ven_codigo = 0; // Asignamos 0 si tiene más de un valor o está vacío
                        }

                        console.log('tipo_ven_codigo:', me.tipo_ven_codigo);

                        // Comprobar variaciones
                        me.inputValid = descuentos.size > 1; // Activa la alerta si hay variaciones
                        me.inputValidtipo = tiposVenta.size > 1; // Activa la alerta si hay variaciones

                        me.getNotasIntercambio(datos);
                        me.getNotasCredito(datos);
                        me.getNotasCLiente(datos);
                    }
                    me.$vs.loading.close();
                })
                .catch(function (error) {
                    console.log(error + ' error');
                    me.$vs.loading.close();
                    me.$vs.notify({
                        title: 'Error',
                        text: 'Error al buscar los datos',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                });
        },
        getNotasIntercambio(datos) {
            let me = this;
            let id = me.periodoSelect.idperiodoescolar;
            me.$vs.loading();
            this.$http.get(this.$server_url + "getNotasIntercambio?institucion=" + datos.idInstitucion + '&periodo=' + id)
                .then(function (res) {
                    me.NotasIntercambio = res.data['notas'];
                    if (!me.NotasIntercambio[0].intercambio_doc.length > 0) {
                        me.verNotasIntercambio = false; // No hay datos válidos
                    } else {
                        me.verNotasIntercambio = true; // Hay datos válidos
                    }
                    me.$vs.loading.close();
                })
                .catch(function (error) {
                    me.$vs.loading.close();
                    console.log(error);
                });
        },
        getNotasCredito(datos) {
            let me = this;
            let id = me.periodoSelect.idperiodoescolar;
            me.$vs.loading();
            this.$http.get(this.$server_url + "getNotasCredito?institucion=" + datos.idInstitucion + '&periodo=' + id)
                .then(function (res) {
                    me.NotasCredito = res.data;
                    if (me.NotasCredito.length > 0) {
                        me.verNotasCredito = true;
                    } else {
                        me.verNotasCredito = false;
                    }
                    me.$vs.loading.close();
                })
                .catch(function (error) {
                    me.$vs.loading.close();
                    console.log(error);
                });
        },
        getNotasCLiente(datos) {
            let me = this;
            let id = me.periodoSelect.idperiodoescolar;
            me.$vs.loading();
            this.$http.get(this.$server_url + "getNotasCLiente?institucion=" + datos.idInstitucion + '&periodo=' + id)
                .then(function (res) {
                    me.NotasCreditoClientes = res.data;
                    if (me.NotasCreditoClientes.length > 0) {
                        me.verNotasCreditoClientes = true;
                    } else {
                        me.verNotasCreditoClientes = false;
                    }
                    me.$vs.loading.close();
                })
                .catch(function (error) {
                    me.$vs.loading.close();
                    console.log(error);
                });
        },
        searchData(tipo) {
            let me = this
            var url = ""
            //minimo 4 caracteres
            if (me.busqueda.cedula.length < 4) {
                me.$vs.notify({
                    title: 'Error',
                    text: 'Debe ingresar al menos 4 caracteres',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                })
                return
            }
            url = 'prefacturasCliente?busqueda=' + me.busqueda.cedula
            me.$vs.loading()
            this.$http.get(this.$server_url + url)
                .then(function (res) {
                    me.arrayCliente = res.data
                    if (me.arrayCliente.length == 0) {
                        me.mostrarBusquedaCliente = false;
                        me.$vs.notify({
                            title: 'Error',
                            text: 'No se encontraron datos',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    } else {
                        me.mostrarBusquedaCliente = true;
                    }
                    me.$vs.loading.close()
                })
                .catch(function (error) {
                    console.log(error + ' error');
                    me.$vs.loading.close()
                    me.$vs.notify({
                        title: 'Error',
                        text: 'Error al buscar los datos',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                })
        },
        change(e) {
            if (e == true) {
                this.tdo = 0;
            }
        },
        handleChange() {
            console.log('Cambio detectado');
        },

        // guardarDatosNotas() { 
        //     let me = this;
        //     this.isLoading = true;
        //     // Validaciones
        //     if (!this.ObjectClientSelected.nombreInstitucion) {
        //         this.isLoading = false;
        //         this.$vs.notify({
        //             title: 'Error',
        //             text: 'La institución es requerida.',
        //             color: 'danger',
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle'
        //         });
        //         return;
        //     }

        //     if (!this.dataclienteunique || !this.dataclienteunique.nombreCliente) {
        //         this.isLoading = false;
        //         this.$vs.notify({
        //             title: 'Error',
        //             text: 'El cliente es requerido.',
        //             color: 'danger',
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle'
        //         });
        //         return;
        //     }

        //     const itemsSeleccionados = this.datosAllFR.filter(item => item.check_real_facturar);

        //     if (itemsSeleccionados.length === 0) {
        //         this.isLoading = false;
        //         this.$vs.notify({
        //             title: 'Error',
        //             text: 'Debe seleccionar al menos un ítem.',
        //             color: 'danger',
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle'
        //         });
        //         return;
        //     }

        //     // Verificar si hay cantidades en 0
        //     const itemsConCantidadCero = itemsSeleccionados.filter(item => item.cantidad_real_facturar == 0);
        //     if (itemsConCantidadCero.length > 0) {
        //         this.isLoading = false;
        //         this.$vs.notify({
        //             title: 'Advertencia',
        //             text: 'Hay ítems seleccionados con cantidad en 0.',
        //             color: 'warning',
        //             iconPack: 'feather',
        //             icon: 'icon-alert-triangle'
        //         });
        //         return;
        //     }

        //     if (me.descuentoVariacion && !me.inputDescuento) {
        //         this.isLoading = false;
        //         this.$vs.notify({
        //             title: 'Error',
        //             text: 'Debes ingresar el descuento.',
        //             color: 'danger',
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle'
        //         });
        //         return;
        //     }

        //     // Reducir los datos de los ítems a solo los campos que necesitas
        //     const datosReducidos = itemsSeleccionados.map(item => ({
        //         pro_codigo: item.pro_codigo,
        //         cantidad_real_facturar: item.cantidad_real_facturar
        //     }));

        //     const datosParaGuardar = {
        //         institucion: this.ObjectClientSelected.idInstitucion,
        //         cliente: this.dataclienteunique,
        //         items: datosReducidos,
        //         subtotal: this.subtotal.toFixed(2),
        //         descuento_porcentaje: this.inputDescuento?this.inputDescuento:this.ven_desc_por_unique[0],
        //         descuento: this.descuento.toFixed(2),
        //         subtotalDescuento: this.subtotalDescuento.toFixed(2),
        //         iva: this.iva.toFixed(2),
        //         transporte: this.transporte.toFixed(2),
        //         total: this.total.toFixed(2),
        //     };

        //     let formData = new FormData();
        //         formData.append("data_detalle", JSON.stringify(datosParaGuardar.items));
        //         formData.append("ven_codigo", me.codigo);
        //         formData.append("id_empresa", me.idempresa);
        //         formData.append("ven_desc_por", datosParaGuardar.descuento_porcentaje);
        //         formData.append("ven_iva_por", 0);
        //         formData.append("ven_descuento", datosParaGuardar.descuento);
        //         formData.append("ven_iva", datosParaGuardar.iva);
        //         formData.append("ven_transporte", datosParaGuardar.transporte);
        //         formData.append("ven_valor", datosParaGuardar.total);
        //         formData.append("ven_subtotal", datosParaGuardar.subtotal);
        //         formData.append("id_ins_depacho", datosParaGuardar.institucion);
        //         formData.append("periodo_id", me.periodoSelect.idperiodoescolar);
        //         formData.append("ven_cliente", datosParaGuardar.cliente.id_usuario);
        //         formData.append("clientesidPerseo", datosParaGuardar.cliente.clientesidPerseo);
        //         formData.append("ven_fecha", me.fechaActual);
        //         formData.append("user_created", me.usuario.idusuario);
        //         formData.append("tipoVenta", me.tipo_ven_codigo);
        //         formData.append("ruc_cliente", datosParaGuardar.cliente.ruc_cliente);
        //         formData.append("letra", me.letra);
        //         formData.append("documentosVentas", JSON.stringify(me.documentosVentas));
        //         // formData.append("data_ventas", JSON.stringify(me.perseo));

        //     // console.log('Datos a guardar:', datosParaGuardar);
        //     for (let [key, value] of formData.entries()) {
        //         console.log(`${key}:`, value);
        //     }
        //     // Aquí puedes realizar una llamada a tu API para guardar los datos
        //     this.$http.post(this.$server_url + "cambioPrefacturasANota", formData)
        //         .then(response => {
        //             // Manejar la respuesta de éxito
        //            if(response.data.status == 0){
        //                 this.$vs.notify({
        //                     title: 'Éxito',
        //                     text: 'Datos guardados correctamente.',
        //                     color: 'success',
        //                     iconPack: 'feather',
        //                     icon: 'icon-check'
        //                 });
        //                 this.getAllPrefacturas(me.datacliente);
        //                 this.popupPrefacturaANotas = false;
        //             }else{
        //                 this.$vs.notify({
        //                     title: 'Error',
        //                     text: 'Datos guardados incorrectamente.',
        //                     color: 'danger',
        //                     iconPack: 'feather',
        //                     icon: 'icon-x'
        //                 });
        //             }
        //         })
        //         .catch(error => {
        //             // Manejar el error
        //             this.$vs.notify({
        //                 title: 'Error',
        //                 text: 'Error al guardar los datos.',
        //                 color: 'danger',
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle'
        //             });
        //             console.error('Error al guardar datos:', error);
        //         })
        //         .finally(() => {
        //             this.isLoading = false;
        //         });
        // },
        guardarDatosNotas() {
            let me = this;
            this.isLoading = true;

            // Validaciones
            return new Promise((resolve, reject) => {
                // Validaciones
                if (!this.ObjectClientSelected.nombreInstitucion) {
                    this.isLoading = false;
                    this.$vs.notify({
                        title: 'Error',
                        text: 'La institución es requerida.',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                    return reject('La institución es requerida.');
                }

                if (!this.dataclienteunique || !this.dataclienteunique.nombreCliente) {
                    this.isLoading = false;
                    this.$vs.notify({
                        title: 'Error',
                        text: 'El cliente es requerido.',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                    return reject('El cliente es requerido.');
                }

                const itemsSeleccionados = this.datosAllFR.filter(item => item.check_real_facturar);

                if (itemsSeleccionados.length === 0) {
                    this.isLoading = false;
                    this.$vs.notify({
                        title: 'Error',
                        text: 'Debe seleccionar al menos un ítem.',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                    return reject('Debe seleccionar al menos un ítem.');
                }

                // Verificar si hay cantidades en 0
                const itemsConCantidadCero = itemsSeleccionados.filter(item => item.cantidad_real_facturar == 0);
                if (itemsConCantidadCero.length > 0) {
                    this.isLoading = false;
                    this.$vs.notify({
                        title: 'Advertencia',
                        text: 'Hay ítems seleccionados con cantidad en 0.',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                    return reject('Hay ítems con cantidad en 0.');
                }

                if (me.descuentoVariacion && !me.inputDescuento) {
                    this.isLoading = false;
                    this.$vs.notify({
                        title: 'Error',
                        text: 'Debes ingresar el descuento.',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                    return reject('Debes ingresar el descuento.');
                }

                // Reducir los datos de los ítems a solo los campos que necesitas
                const datosReducidos = itemsSeleccionados.map(item => ({
                    pro_codigo: item.pro_codigo,
                    cantidad_real_facturar: item.cantidad_real_facturar
                }));

                const datosParaGuardar = {
                    institucion: this.ObjectClientSelected.idInstitucion,
                    cliente: this.dataclienteunique,
                    items: datosReducidos,
                    subtotal: this.subtotal.toFixed(2),
                    descuento_porcentaje: this.inputDescuento ? this.inputDescuento : this.ven_desc_por_unique[0],
                    descuento: this.descuento.toFixed(2),
                    subtotalDescuento: this.subtotalDescuento.toFixed(2),
                    iva: this.iva.toFixed(2),
                    transporte: this.transporte.toFixed(2),
                    total: this.total.toFixed(2),

                };

                let formData = new FormData();
                formData.append("data_detalle", JSON.stringify(datosParaGuardar.items));
                formData.append("ven_codigo", me.codigo);
                formData.append("id_empresa", me.idempresa);
                formData.append("ven_desc_por", datosParaGuardar.descuento_porcentaje);
                formData.append("ven_iva_por", 0);
                formData.append("ven_descuento", datosParaGuardar.descuento);
                formData.append("ven_iva", datosParaGuardar.iva);
                formData.append("ven_transporte", datosParaGuardar.transporte);
                formData.append("ven_valor", datosParaGuardar.total);
                formData.append("ven_subtotal", datosParaGuardar.subtotal);
                formData.append("id_ins_depacho", datosParaGuardar.institucion);
                formData.append("periodo_id", me.periodoSelect.idperiodoescolar);
                formData.append("ven_cliente", datosParaGuardar.cliente.id_usuario);
                formData.append("clientesidPerseo", datosParaGuardar.cliente.clientesidPerseo);
                formData.append("ven_fecha", me.fechaActual);
                formData.append("user_created", me.usuario.idusuario);
                formData.append("tipoVenta", me.tipo_ven_codigo);
                formData.append("ruc_cliente", datosParaGuardar.cliente.ruc_cliente);
                formData.append("letra", me.letra);
                formData.append("documentosVentas", JSON.stringify(me.documentosVentas));
                formData.append("codigosVentas", JSON.stringify(me.codigosVentas));

                // Llamada al primer método cambioPrefacturasANota
                this.$http.post(this.$server_url + "cambioPrefacturasANota", formData)
                    .then(response => {
                        // Manejar la respuesta de éxito
                        if (response.data.status == 0) {
                            this.$vs.notify({
                                title: 'Éxito',
                                text: 'Datos guardados correctamente.',
                                color: 'success',
                                iconPack: 'feather',
                                icon: 'icon-check'
                            });
                            this.getAllPrefacturas(me.datacliente);
                            this.popupPrefacturaANotas = false;
                        } else {
                            this.$vs.notify({
                                title: 'Error',
                                text: 'Datos guardados incorrectamente.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-x'
                            });
                        }
                    })
                    .catch(error => {
                        // Manejar el error
                        this.$vs.notify({
                            title: 'Error',
                            text: 'Error al guardar los datos.',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                        this.isLoading = false;
                        console.error('Error al guardar datos:', error);
                        reject(error); // Rechaza la promesa si ocurre un error en la llamada principal
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            });
        },
        getDocumentos(documentos, empresa) {
            let me = this;
            me.$vs.loading();
            this.$http.get(this.$server_url + 'devoluciones?CargarDocumentos=yes&documentos=' + documentos + '&empresa=' + empresa)
                .then((res) => {
                    me.DocumentoVenta = res.data;
                    if (me.DocumentoVenta.length > 0) {
                        let codigo = me.DocumentoVenta[0].ven_codigo;
                        let empresa = me.DocumentoVenta[0].empresa_id;
                        this.getDocumentosDetalles(codigo, empresa);
                    } else {
                        this.$vs.notify({
                            title: 'Error',
                            text: 'Documento no encontrado.',
                            type: 'error',
                        });
                    }

                    me.$vs.loading.close();
                })
                .catch((err) => {
                    console.error(err);
                    this.$vs.notify({
                        title: 'Error',
                        text: 'Hubo un problema al cargar los documentos.',
                        type: 'error',
                    });
                    me.$vs.loading.close();
                });
        },
        getDocumentosDetalles(codigo, empresa) {
            let me = this;
            // console.log(codigo, empresa,'dsdsadsaddsa');
            me.$vs.loading();
            this.$http.get(this.$server_url + 'devoluciones?CargarDocumentosDetalles=yes&codigo=' + codigo + '&empresa=' + empresa)
                .then((res) => {
                    this.DocumentoDetalleVenta = res.data;
                    if (this.DocumentoDetalleVenta.length > 0) {
                        this.popupDocumento = true;
                    } else {
                        this.$vs.notify({
                            title: 'Error',
                            text: 'Detalle Documento no encontrado.',
                            type: 'error',
                        });
                    }
                    me.$vs.loading.close();
                })
                .catch((err) => {
                    console.error(err);
                    this.$vs.notify({
                        title: 'Error',
                        text: 'Hubo un problema al cargar los detalles de los documentos.',
                        type: 'error',
                    });
                    me.$vs.loading.close();
                });
        },
        guardarDatosNotaCredito() {
            let me = this;
            this.isLoading = true;

            // Validaciones
            return new Promise((resolve, reject) => {
                // Validaciones
                if (!this.ObjectClientSelected.nombreInstitucion) {
                    this.isLoading = false;
                    this.$vs.notify({
                        title: 'Error',
                        text: 'La institución es requerida.',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                    return reject('La institución es requerida.');
                }

                if (!this.dataclienteunique || !this.dataclienteunique.nombreCliente) {
                    this.isLoading = false;
                    this.$vs.notify({
                        title: 'Error',
                        text: 'El cliente es requerido.',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                    return reject('El cliente es requerido.');
                }

                const itemsSeleccionados = this.datosAllFR.filter(item => item.check_real_facturar);

                if (itemsSeleccionados.length === 0) {
                    this.isLoading = false;
                    this.$vs.notify({
                        title: 'Error',
                        text: 'Debe seleccionar al menos un ítem.',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                    return reject('Debe seleccionar al menos un ítem.');
                }

                // Verificar si hay cantidades en 0
                const itemsConCantidadCero = itemsSeleccionados.filter(item => item.cantidad_real_facturar == 0);
                if (itemsConCantidadCero.length > 0) {
                    this.isLoading = false;
                    this.$vs.notify({
                        title: 'Advertencia',
                        text: 'Hay ítems seleccionados con cantidad en 0.',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                    return reject('Hay ítems con cantidad en 0.');
                }

                if (me.descuentoVariacion && !me.inputDescuento) {
                    this.isLoading = false;
                    this.$vs.notify({
                        title: 'Error',
                        text: 'Debes ingresar el descuento.',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                    return reject('Debes ingresar el descuento.');
                }

                // Reducir los datos de los ítems a solo los campos que necesitas
                const datosReducidos = itemsSeleccionados.map(item => ({
                    pro_codigo: item.pro_codigo,
                    cantidad_real_facturar: item.cantidad_real_facturar,
                    precio: item.det_ven_valor_u
                }));

                const datosParaGuardar = {
                    institucion: this.ObjectClientSelected.idInstitucion,
                    cliente: this.dataclienteunique,
                    items: datosReducidos,
                    subtotal: this.subtotal.toFixed(2),
                    descuento_porcentaje: this.inputDescuento ? this.inputDescuento : this.ven_desc_por_unique[0],
                    descuento: this.descuento.toFixed(2),
                    subtotalDescuento: this.subtotalDescuento.toFixed(2),
                    iva: this.iva.toFixed(2),
                    transporte: this.transporte.toFixed(2),
                    total: this.total.toFixed(2),

                };

                let formData = new FormData();
                formData.append("data_detalle", JSON.stringify(datosParaGuardar.items));
                formData.append("ven_codigo", me.codigo);
                formData.append("id_empresa", me.idempresa);
                formData.append("ven_desc_por", datosParaGuardar.descuento_porcentaje);
                formData.append("ven_iva_por", 0);
                formData.append("ven_descuento", datosParaGuardar.descuento);
                formData.append("ven_iva", datosParaGuardar.iva);
                formData.append("ven_transporte", datosParaGuardar.transporte);
                formData.append("ven_valor", datosParaGuardar.total);
                formData.append("ven_subtotal", datosParaGuardar.subtotal);
                formData.append("id_ins_depacho", datosParaGuardar.institucion);
                formData.append("periodo_id", me.periodoSelect.idperiodoescolar);
                formData.append("ven_cliente", datosParaGuardar.cliente.id_usuario);
                formData.append("clientesidPerseo", datosParaGuardar.cliente.clientesidPerseo);
                formData.append("ven_fecha", me.fechaActual);
                formData.append("user_created", me.usuario.idusuario);
                formData.append("tipoVenta", me.tipo_ven_codigo);
                formData.append("ruc_cliente", datosParaGuardar.cliente.ruc_cliente);
                formData.append("letra", me.letra);
                formData.append("documentosVentas", JSON.stringify(me.documentosVentas));

                // Llamada al primer método cambioPrefacturasANota
                this.$http.post(this.$server_url + "cambioDesfasANotaCredito", formData)
                    .then(response => {
                        // Manejar la respuesta de éxito
                        if (response.data.status == 0) {
                            this.$vs.notify({
                                title: 'Éxito',
                                text: 'Datos guardados correctamente.',
                                color: 'success',
                                iconPack: 'feather',
                                icon: 'icon-check'
                            });
                            this.getAllPrefacturas(me.datacliente);
                            this.popupNotaDeCredito = false;
                        } else {
                            this.$vs.notify({
                                title: 'Error',
                                text: 'Datos guardados incorrectamente.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-x'
                            });
                        }
                    })
                    .catch(error => {
                        // Manejar el error
                        this.$vs.notify({
                            title: 'Error',
                            text: 'Error al guardar los datos.',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                        this.isLoading = false;
                        console.error('Error al guardar datos:', error);
                        reject(error); // Rechaza la promesa si ocurre un error en la llamada principal
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            });
        },
        documentoNoSeleccionado() {
            this.popupSRI = false;
        },
        documentoActualizado() {
            this.popupSRI = false;
            this.getAllPrefacturas(this.datacliente);
        },
    },
};
</script>

<style>
.text {
    z-index: 9;
    background: var(--bg);
    color: var(--color);
    font-size: 11px;
    padding: 1.5px;
    border-radius: 1px;
    height: fit-content;
    cursor: pointer;
    box-shadow: 0 4px 16px 4px rgba(0, 0, 0, 0.15);
}

.table-container {
    max-height: 605px;
    overflow-y: auto;
}

.checked-count {
    margin-top: 10px;
    /* Espaciado opcional */
}

.active-button {
    background-color: #a3a2a24b;
    /* Verde para indicar activo */
    color: rgba(114, 114, 114, 0.671);
    /* Color del texto */
}
</style><style lang="scss">
.hide-close .vs-popup--close {
    display: none;
}
</style>
